export const naicsSectors = [
  { label: "11", value: "Agriculture, Forestry, Fishing and Hunting" },
  { label: "111110", value: "Soybean Farming" },
  { label: "111120", value: "Oilseed (except Soybean) Farming" },
  { label: "111130", value: "Dry Pea and Bean Farming" },
  { label: "111140", value: "Wheat Farming" },
  { label: "111150", value: "Corn Farming" },
  { label: "111160", value: "Rice Farming" },
  { label: "111191", value: "Oilseed and Grain Combination Farming" },
  { label: "111199", value: "All Other Grain Farming" },
  { label: "111211", value: "Potato Farming" },
  { label: "111219", value: "Other Vegetable (except Potato) and Melon Farming" },
  { label: "111310", value: "Orange Groves" },
  { label: "111320", value: "Citrus (except Orange) Groves" },
  { label: "111331", value: "Apple Orchards" },
  { label: "111332", value: "Grape Vineyards" },
  { label: "111333", value: "Strawberry Farming" },
  { label: "111334", value: "Berry (except Strawberry) Farming" },
  { label: "111335", value: "Tree Nut Farming" },
  { label: "111336", value: "Fruit and Tree Nut Combination Farming" },
  { label: "111339", value: "Other Noncitrus Fruit Farming" },
  { label: "111411", value: "Mushroom Production" },
  { label: "111419", value: "Other Food Crops Grown Under Cover" },
  { label: "111421", value: "Nursery and Tree Production" },
  { label: "111422", value: "Floriculture Production" },
  { label: "111910", value: "Tobacco Farming" },
  { label: "111920", value: "Cotton Farming" },
  { label: "111930", value: "Sugarcane Farming" },
  { label: "111940", value: "Hay Farming" },
  { label: "111991", value: "Sugar Beet Farming" },
  { label: "111992", value: "Peanut Farming" },
  { label: "111998", value: "All Other Miscellaneous Crop Farming" },
  { label: "112111", value: "Beef Cattle Ranching and Farming" },
  { label: "112112", value: "Cattle Feedlots" },
  { label: "112120", value: "Dairy Cattle and Milk Production" },
  { label: "112130", value: "Dual-Purpose Cattle Ranching and Farming" },
  { label: "112210", value: "Hog and Pig Farming" },
  { label: "112310", value: "Chicken Egg Production" },
  { label: "112320", value: "Broilers and Other Meat Type Chicken Production" },
  { label: "112330", value: "Turkey Production" },
  { label: "112340", value: "Poultry Hatcheries" },
  { label: "112390", value: "Other Poultry Production" },
  { label: "112410", value: "Sheep Farming" },
  { label: "112420", value: "Goat Farming" },
  { label: "112511", value: "Finfish Farming and Fish Hatcheries" },
  { label: "112512", value: "Shellfish Farming" },
  { label: "112519", value: "Other Aquaculture" },
  { label: "112910", value: "Apiculture" },
  { label: "112920", value: "Horses and Other Equine Production" },
  { label: "112930", value: "Fur-Bearing Animal and Rabbit Production" },
  { label: "112990", value: "All Other Animal Production" },
  { label: "113110", value: "Timber Tract Operations" },
  { label: "113210", value: "Forest Nurseries and Gathering of Forest Products" },
  { label: "113310", value: "Logging" },
  { label: "114111", value: "Finfish Fishing" },
  { label: "114112", value: "Shellfish Fishing" },
  { label: "114119", value: "Other Marine Fishing" },
  { label: "114210", value: "Hunting and Trapping" },
  { label: "115111", value: "Cotton Ginning" },
  { label: "115112", value: "Soil Preparation, Planting, and Cultivating" },
  { label: "115113", value: "Crop Harvesting, Primarily by Machine" },
  { label: "115114", value: "Postharvest Crop Activities (except Cotton Ginning)" },
  { label: "115115", value: "Farm Labor Contractors and Crew Leaders" },
  { label: "115116", value: "Farm Management Services" },
  { label: "115210", value: "Support Activities for Animal Production" },
  { label: "115310", value: "Support Activities for Forestry" },
  { label: "1111", value: "Oilseed and Grain Farming" },
  { label: "111110", value: "Soybean Farming" },
  { label: "111120", value: "Oilseed (except Soybean) Farming" },
  { label: "111130", value: "Dry Pea and Bean Farming" },
  { label: "111140", value: "Wheat Farming" },
  { label: "111150", value: "Corn Farming" },
  { label: "111160", value: "Rice Farming" },
  { label: "111191", value: "Oilseed and Grain Combination Farming" },
  { label: "111199", value: "All Other Grain Farming" },
  { label: "1112", value: "Vegetable and Melon Farming" },
  { label: "111211", value: "Potato Farming" },
  { label: "111219", value: "Other Vegetable (except Potato) and Melon Farming" },
  { label: "1113", value: "Fruit and Tree Nut Farming" },
  { label: "111310", value: "Orange Groves" },
  { label: "111320", value: "Citrus (except Orange) Groves" },
  { label: "111331", value: "Apple Orchards" },
  { label: "111332", value: "Grape Vineyards" },
  { label: "111333", value: "Strawberry Farming" },
  { label: "111334", value: "Berry (except Strawberry) Farming" },
  { label: "111335", value: "Tree Nut Farming" },
  { label: "111336", value: "Fruit and Tree Nut Combination Farming" },
  { label: "111339", value: "Other Noncitrus Fruit Farming" },
  { label: "1114", value: "Greenhouse, Nursery, and Floriculture Production" },
  { label: "111411", value: "Mushroom Production" },
  { label: "111419", value: "Other Food Crops Grown Under Cover" },
  { label: "111421", value: "Nursery and Tree Production" },
  { label: "111422", value: "Floriculture Production" },
  { label: "1119", value: "Other Crop Farming" },
  { label: "111910", value: "Tobacco Farming" },
  { label: "111920", value: "Cotton Farming" },
  { label: "111930", value: "Sugarcane Farming" },
  { label: "111940", value: "Hay Farming" },
  { label: "111991", value: "Sugar Beet Farming" },
  { label: "111992", value: "Peanut Farming" },
  { label: "111998", value: "All Other Miscellaneous Crop Farming" },
  { label: "1121", value: "Cattle Ranching and Farming" },
  { label: "112111", value: "Beef Cattle Ranching and Farming" },
  { label: "112112", value: "Cattle Feedlots" },
  { label: "112120", value: "Dairy Cattle and Milk Production" },
  { label: "112130", value: "Dual-Purpose Cattle Ranching and Farming" },
  { label: "1122", value: "Hog and Pig Farming" },
  { label: "112210", value: "Hog and Pig Farming" },
  { label: "1123", value: "Poultry and Egg Production" },
  { label: "112310", value: "Chicken Egg Production" },
  { label: "112320", value: "Broilers and Other Meat Type Chicken Production" },
  { label: "112330", value: "Turkey Production" },
  { label: "112340", value: "Poultry Hatcheries" },
  { label: "112390", value: "Other Poultry Production" },
  { label: "1124", value: "Sheep and Goat Farming" },
  { label: "112410", value: "Sheep Farming" },
  { label: "112420", value: "Goat Farming" },
  { label: "1125", value: "Aquaculture" },
  { label: "112511", value: "Finfish Farming and Fish Hatcheries" },
  { label: "112512", value: "Shellfish Farming" },
  { label: "112519", value: "Other Aquaculture" },
  { label: "1129", value: "Other Animal Production" },
  { label: "112910", value: "Apiculture" },
  { label: "112920", value: "Horses and Other Equine Production" },
  { label: "112930", value: "Fur-Bearing Animal and Rabbit Production" },
  { label: "112990", value: "All Other Animal Production" },
  { label: "1131", value: "Timber Tract Operations" },
  { label: "113110", value: "Timber Tract Operations" },
  { label: "1132", value: "Forest Nurseries and Gathering of Forest Products" },
  { label: "113210", value: "Forest Nurseries and Gathering of Forest Products" },
  { label: "1133", value: "Logging" },
  { label: "113310", value: "Logging" },
  { label: "1141", value: "Fishing" },
  { label: "114111", value: "Finfish Fishing" },
  { label: "114112", value: "Shellfish Fishing" },
  { label: "114119", value: "Other Marine Fishing" },
  { label: "1142", value: "Hunting and Trapping" },
  { label: "114210", value: "Hunting and Trapping" },
  { label: "1151", value: "Support Activities for Crop Production" },
  { label: "115111", value: "Cotton Ginning" },
  { label: "115112", value: "Soil Preparation, Planting, and Cultivating" },
  { label: "115113", value: "Crop Harvesting, Primarily by Machine" },
  { label: "115114", value: "Postharvest Crop Activities (except Cotton Ginning)" },
  { label: "115115", value: "Farm Labor Contractors and Crew Leaders" },
  { label: "115116", value: "Farm Management Services" },
  { label: "1152", value: "Support Activities for Animal Production" },
  { label: "115210", value: "Support Activities for Animal Production" },
  { label: "1153", value: "Support Activities for Forestry" },
  { label: "115310", value: "Support Activities for Forestry" },
  { label: "21", value: "Mining, Quarrying, and Oil and Gas Extraction" },
  { label: "211120", value: "Crude Petroleum Extraction" },
  { label: "211130", value: "Natural Gas Extraction" },
  { label: "212114", value: "Surface Coal Mining" },
  { label: "212115", value: "Underground Coal Mining" },
  { label: "212210", value: "Iron Ore Mining" },
  { label: "212220", value: "Gold Ore and Silver Ore Mining" },
  { label: "212230", value: "Copper, Nickel, Lead, and Zinc Mining" },
  { label: "212290", value: "Other Metal Ore Mining" },
  { label: "212311", value: "Dimension Stone Mining and Quarrying" },
  { label: "212312", value: "Crushed and Broken Limestone Mining and Quarrying" },
  { label: "212313", value: "Crushed and Broken Granite Mining and Quarrying" },
  { label: "212319", value: "Other Crushed and Broken Stone Mining and Quarrying" },
  { label: "212321", value: "Construction Sand and Gravel Mining" },
  { label: "212322", value: "Industrial Sand Mining" },
  { label: "212323", value: "Kaolin, Clay, and Ceramic and Refractory Minerals Mining" },
  { label: "212390", value: "Other Nonmetallic Mineral Mining and Quarrying" },
  { label: "213111", value: "Drilling Oil and Gas Wells" },
  { label: "213112", value: "Support Activities for Oil and Gas Operations" },
  { label: "213113", value: "Support Activities for Coal Mining" },
  { label: "213114", value: "Support Activities for Metal Mining" },
  {
    label: "213115",
    value: "Support Activities for Nonmetallic Minerals (except Fuels) Mining",
  },
  { label: "2111", value: "Oil and Gas Extraction" },
  { label: "211120", value: "Crude Petroleum Extraction" },
  { label: "211130", value: "Natural Gas Extraction" },
  { label: "2121", value: "Coal Mining" },
  { label: "212114", value: "Surface Coal Mining" },
  { label: "212115", value: "Underground Coal Mining" },
  { label: "2122", value: "Metal Ore Mining" },
  { label: "212210", value: "Iron Ore Mining" },
  { label: "212220", value: "Gold Ore and Silver Ore Mining" },
  { label: "212230", value: "Copper, Nickel, Lead, and Zinc Mining" },
  { label: "212290", value: "Other Metal Ore Mining" },
  { label: "2123", value: "Nonmetallic Mineral Mining and Quarrying" },
  { label: "212311", value: "Dimension Stone Mining and Quarrying" },
  { label: "212312", value: "Crushed and Broken Limestone Mining and Quarrying" },
  { label: "212313", value: "Crushed and Broken Granite Mining and Quarrying" },
  { label: "212319", value: "Other Crushed and Broken Stone Mining and Quarrying" },
  { label: "212321", value: "Construction Sand and Gravel Mining" },
  { label: "212322", value: "Industrial Sand Mining" },
  { label: "212323", value: "Kaolin, Clay, and Ceramic and Refractory Minerals Mining" },
  { label: "212390", value: "Other Nonmetallic Mineral Mining and Quarrying" },
  { label: "2131", value: "Support Activities for Mining" },
  { label: "213111", value: "Drilling Oil and Gas Wells" },
  { label: "213112", value: "Support Activities for Oil and Gas Operations" },
  { label: "213113", value: "Support Activities for Coal Mining" },
  { label: "213114", value: "Support Activities for Metal Mining" },
  {
    label: "213115",
    value: "Support Activities for Nonmetallic Minerals (except Fuels) Mining",
  },
  { label: "22", value: "Utilities" },
  { label: "221111", value: "Hydroelectric Power Generation" },
  { label: "221112", value: "Fossil Fuel Electric Power Generation" },
  { label: "221113", value: "Nuclear Electric Power Generation" },
  { label: "221114", value: "Solar Electric Power Generation" },
  { label: "221115", value: "Wind Electric Power Generation" },
  { label: "221116", value: "Geothermal Electric Power Generation" },
  { label: "221117", value: "Biomass Electric Power Generation" },
  { label: "221118", value: "Other Electric Power Generation" },
  { label: "221121", value: "Electric Bulk Power Transmission and Control" },
  { label: "221122", value: "Electric Power Distribution" },
  { label: "221210", value: "Natural Gas Distribution" },
  { label: "221310", value: "Water Supply and Irrigation Systems" },
  { label: "221320", value: "Sewage Treatment Facilities" },
  { label: "221330", value: "Steam and Air-Conditioning Supply" },
  { label: "2211", value: "Electric Power Generation, Transmission and Distribution" },
  { label: "221111", value: "Hydroelectric Power Generation" },
  { label: "221112", value: "Fossil Fuel Electric Power Generation" },
  { label: "221113", value: "Nuclear Electric Power Generation" },
  { label: "221114", value: "Solar Electric Power Generation" },
  { label: "221115", value: "Wind Electric Power Generation" },
  { label: "221116", value: "Geothermal Electric Power Generation" },
  { label: "221117", value: "Biomass Electric Power Generation" },
  { label: "221118", value: "Other Electric Power Generation" },
  { label: "221121", value: "Electric Bulk Power Transmission and Control" },
  { label: "221122", value: "Electric Power Distribution" },
  { label: "2212", value: "Natural Gas Distribution" },
  { label: "221210", value: "Natural Gas Distribution" },
  { label: "2213", value: "Water, Sewage and Other Systems" },
  { label: "221310", value: "Water Supply and Irrigation Systems" },
  { label: "221320", value: "Sewage Treatment Facilities" },
  { label: "221330", value: "Steam and Air-Conditioning Supply" },
  { label: "23", value: "Construction" },
  {
    label: "236115",
    value: "New Single-Family Housing Construction (except For-Sale Builders)",
  },
  {
    label: "236116",
    value: "New Multifamily Housing Construction (except For-Sale Builders)",
  },
  { label: "236117", value: "New Housing For-Sale Builders" },
  { label: "236118", value: "Residential Remodelers" },
  { label: "236210", value: "Industrial Building Construction" },
  { label: "236220", value: "Commercial and Institutional Building Construction" },
  { label: "237110", value: "Water and Sewer Line and Related Structures Construction" },
  { label: "237120", value: "Oil and Gas Pipeline and Related Structures Construction" },
  {
    label: "237130",
    value: "Power and Communication Line and Related Structures Construction",
  },
  { label: "237210", value: "Land Subdivision" },
  { label: "237310", value: "Highway, Street, and Bridge Construction" },
  { label: "237990", value: "Other Heavy and Civil Engineering Construction" },
  { label: "238110", value: "Poured Concrete Foundation and Structure Contractors" },
  { label: "238120", value: "Structural Steel and Precast Concrete Contractors" },
  { label: "238130", value: "Framing Contractors" },
  { label: "238140", value: "Masonry Contractors" },
  { label: "238150", value: "Glass and Glazing Contractors" },
  { label: "238160", value: "Roofing Contractors" },
  { label: "238170", value: "Siding Contractors" },
  {
    label: "238190",
    value: "Other Foundation, Structure, and Building Exterior Contractors",
  },
  {
    label: "238210",
    value: "Electrical Contractors and Other Wiring Installation Contractors",
  },
  { label: "238220", value: "Plumbing, Heating, and Air-Conditioning Contractors" },
  { label: "238290", value: "Other Building Equipment Contractors" },
  { label: "238310", value: "Drywall and Insulation Contractors" },
  { label: "238320", value: "Painting and Wall Covering Contractors" },
  { label: "238330", value: "Flooring Contractors" },
  { label: "238340", value: "Tile and Terrazzo Contractors" },
  { label: "238350", value: "Finish Carpentry Contractors" },
  { label: "238390", value: "Other Building Finishing Contractors" },
  { label: "238910", value: "Site Preparation Contractors" },
  { label: "238990", value: "All Other Specialty Trade Contractors" },
  { label: "2361", value: "Residential Building Construction" },
  {
    label: "236115",
    value: "New Single-Family Housing Construction (except For-Sale Builders)",
  },
  {
    label: "236116",
    value: "New Multifamily Housing Construction (except For-Sale Builders)",
  },
  { label: "236117", value: "New Housing For-Sale Builders" },
  { label: "236118", value: "Residential Remodelers" },
  { label: "2362", value: "Nonresidential Building Construction" },
  { label: "236210", value: "Industrial Building Construction" },
  { label: "236220", value: "Commercial and Institutional Building Construction" },
  { label: "2371", value: "Utility System Construction" },
  { label: "237110", value: "Water and Sewer Line and Related Structures Construction" },
  { label: "237120", value: "Oil and Gas Pipeline and Related Structures Construction" },
  {
    label: "237130",
    value: "Power and Communication Line and Related Structures Construction",
  },
  { label: "2372", value: "Land Subdivision" },
  { label: "237210", value: "Land Subdivision" },
  { label: "2373", value: "Highway, Street, and Bridge Construction" },
  { label: "237310", value: "Highway, Street, and Bridge Construction" },
  { label: "2379", value: "Other Heavy and Civil Engineering Construction" },
  { label: "237990", value: "Other Heavy and Civil Engineering Construction" },
  { label: "2381", value: "Foundation, Structure, and Building Exterior Contractors" },
  { label: "238110", value: "Poured Concrete Foundation and Structure Contractors" },
  { label: "238120", value: "Structural Steel and Precast Concrete Contractors" },
  { label: "238130", value: "Framing Contractors" },
  { label: "238140", value: "Masonry Contractors" },
  { label: "238150", value: "Glass and Glazing Contractors" },
  { label: "238160", value: "Roofing Contractors" },
  { label: "238170", value: "Siding Contractors" },
  {
    label: "238190",
    value: "Other Foundation, Structure, and Building Exterior Contractors",
  },
  { label: "2382", value: "Building Equipment Contractors" },
  {
    label: "238210",
    value: "Electrical Contractors and Other Wiring Installation Contractors",
  },
  { label: "238220", value: "Plumbing, Heating, and Air-Conditioning Contractors" },
  { label: "238290", value: "Other Building Equipment Contractors" },
  { label: "2383", value: "Building Finishing Contractors" },
  { label: "238310", value: "Drywall and Insulation Contractors" },
  { label: "238320", value: "Painting and Wall Covering Contractors" },
  { label: "238330", value: "Flooring Contractors" },
  { label: "238340", value: "Tile and Terrazzo Contractors" },
  { label: "238350", value: "Finish Carpentry Contractors" },
  { label: "238390", value: "Other Building Finishing Contractors" },
  { label: "2389", value: "Other Specialty Trade Contractors" },
  { label: "238910", value: "Site Preparation Contractors" },
  { label: "238990", value: "All Other Specialty Trade Contractors" },
  { label: "31", value: "Manufacturing" },
  { label: "311111", value: "Dog and Cat Food Manufacturing" },
  { label: "311119", value: "Other Animal Food Manufacturing" },
  { label: "311211", value: "Flour Milling" },
  { label: "311212", value: "Rice Milling" },
  { label: "311213", value: "Malt Manufacturing" },
  { label: "311221", value: "Wet Corn Milling and Starch Manufacturing" },
  { label: "311224", value: "Soybean and Other Oilseed Processing" },
  { label: "311225", value: "Fats and Oils Refining and Blending" },
  { label: "311230", value: "Breakfast Cereal Manufacturing" },
  { label: "311313", value: "Beet Sugar Manufacturing" },
  { label: "311314", value: "Cane Sugar Manufacturing" },
  { label: "311340", value: "Nonchocolate Confectionery Manufacturing" },
  {
    label: "311351",
    value: "Chocolate and Confectionery Manufacturing from Cacao Beans",
  },
  { label: "311352", value: "Confectionery Manufacturing from Purchased Chocolate" },
  { label: "311411", value: "Frozen Fruit, Juice, and Vegetable Manufacturing" },
  { label: "311412", value: "Frozen Specialty Food Manufacturing" },
  { label: "311421", value: "Fruit and Vegetable Canning" },
  { label: "311422", value: "Specialty Canning" },
  { label: "311423", value: "Dried and Dehydrated Food Manufacturing" },
  { label: "311511", value: "Fluid Milk Manufacturing" },
  { label: "311512", value: "Creamery Butter Manufacturing" },
  { label: "311513", value: "Cheese Manufacturing" },
  {
    label: "311514",
    value: "Dry, Condensed, and Evaporated Dairy Product Manufacturing",
  },
  { label: "311520", value: "Ice Cream and Frozen Dessert Manufacturing" },
  { label: "311611", value: "Animal (except Poultry) Slaughtering" },
  { label: "311612", value: "Meat Processed from Carcasses" },
  { label: "311613", value: "Rendering and Meat Byproduct Processing" },
  { label: "311615", value: "Poultry Processing" },
  { label: "311710", value: "Seafood Product Preparation and Packaging" },
  { label: "311811", value: "Retail Bakeries" },
  { label: "311812", value: "Commercial Bakeries" },
  { label: "311813", value: "Frozen Cakes, Pies, and Other Pastries Manufacturing" },
  { label: "311821", value: "Cookie and Cracker Manufacturing" },
  {
    label: "311824",
    value: "Dry Pasta, Dough, and Flour Mixes Manufacturing from Purchased Flour",
  },
  { label: "311830", value: "Tortilla Manufacturing" },
  { label: "311911", value: "Roasted Nuts and Peanut Butter Manufacturing" },
  { label: "311919", value: "Other Snack Food Manufacturing" },
  { label: "311920", value: "Coffee and Tea Manufacturing" },
  { label: "311930", value: "Flavoring Syrup and Concentrate Manufacturing" },
  {
    label: "311941",
    value: "Mayonnaise, Dressing, and Other Prepared Sauce Manufacturing",
  },
  { label: "311942", value: "Spice and Extract Manufacturing" },
  { label: "311991", value: "Perishable Prepared Food Manufacturing" },
  { label: "311999", value: "All Other Miscellaneous Food Manufacturing" },
  { label: "312111", value: "Soft Drink Manufacturing" },
  { label: "312112", value: "Bottled Water Manufacturing" },
  { label: "312113", value: "Ice Manufacturing" },
  { label: "312120", value: "Breweries" },
  { label: "312130", value: "Wineries" },
  { label: "312140", value: "Distilleries" },
  { label: "312230", value: "Tobacco Manufacturing" },
  { label: "313110", value: "Fiber, Yarn, and Thread Mills" },
  { label: "313210", value: "Broadwoven Fabric Mills" },
  { label: "313220", value: "Narrow Fabric Mills and Schiffli Machine Embroidery" },
  { label: "313230", value: "Nonwoven Fabric Mills" },
  { label: "313240", value: "Knit Fabric Mills" },
  { label: "313310", value: "Textile and Fabric Finishing Mills" },
  { label: "313320", value: "Fabric Coating Mills" },
  { label: "314110", value: "Carpet and Rug Mills" },
  { label: "314120", value: "Curtain and Linen Mills" },
  { label: "314910", value: "Textile Bag and Canvas Mills" },
  { label: "314994", value: "Rope, Cordage, Twine, Tire Cord, and Tire Fabric Mills" },
  { label: "314999", value: "All Other Miscellaneous Textile Product Mills" },
  { label: "315120", value: "Apparel Knitting Mills" },
  { label: "315210", value: "Cut and Sew Apparel Contractors" },
  { label: "315250", value: "Cut and Sew Apparel Manufacturing (except Contractors)" },
  { label: "315990", value: "Apparel Accessories and Other Apparel Manufacturing" },
  { label: "316110", value: "Leather and Hide Tanning and Finishing" },
  { label: "316210", value: "Footwear Manufacturing" },
  { label: "316990", value: "Other Leather and Allied Product Manufacturing" },
  { label: "321113", value: "Sawmills" },
  { label: "321114", value: "Wood Preservation" },
  { label: "321211", value: "Hardwood Veneer and Plywood Manufacturing" },
  { label: "321212", value: "Softwood Veneer and Plywood Manufacturing" },
  { label: "321215", value: "Engineered Wood Member Manufacturing" },
  { label: "321219", value: "Reconstituted Wood Product Manufacturing" },
  { label: "321911", value: "Wood Window and Door Manufacturing" },
  { label: "321912", value: "Cut Stock, Resawing Lumber, and Planing" },
  { label: "321918", value: "Other Millwork (including Flooring)" },
  { label: "321920", value: "Wood Container and Pallet Manufacturing" },
  { label: "321991", value: "Manufactured Home (Mobile Home) Manufacturing" },
  { label: "321992", value: "Prefabricated Wood Building Manufacturing" },
  { label: "321999", value: "All Other Miscellaneous Wood Product Manufacturing" },
  { label: "322110", value: "Pulp Mills" },
  { label: "322120", value: "Paper Mills" },
  { label: "322130", value: "Paperboard Mills" },
  { label: "322211", value: "Corrugated and Solid Fiber Box Manufacturing" },
  { label: "322212", value: "Folding Paperboard Box Manufacturing" },
  { label: "322219", value: "Other Paperboard Container Manufacturing" },
  { label: "322220", value: "Paper Bag and Coated and Treated Paper Manufacturing" },
  { label: "322230", value: "Stationery Product Manufacturing" },
  { label: "322291", value: "Sanitary Paper Product Manufacturing" },
  { label: "322299", value: "All Other Converted Paper Product Manufacturing" },
  { label: "323111", value: "Commercial Printing (except Screen and Books)" },
  { label: "323113", value: "Commercial Screen Printing" },
  { label: "323117", value: "Books Printing" },
  { label: "323120", value: "Support Activities for Printing" },
  { label: "324110", value: "Petroleum Refineries" },
  { label: "324121", value: "Asphalt Paving Mixture and Block Manufacturing" },
  { label: "324122", value: "Asphalt Shingle and Coating Materials Manufacturing" },
  { label: "324191", value: "Petroleum Lubricating Oil and Grease Manufacturing" },
  { label: "324199", value: "All Other Petroleum and Coal Products Manufacturing" },
  { label: "325110", value: "Petrochemical Manufacturing" },
  { label: "325120", value: "Industrial Gas Manufacturing" },
  { label: "325130", value: "Synthetic Dye and Pigment Manufacturing" },
  { label: "325180", value: "Other Basic Inorganic Chemical Manufacturing" },
  { label: "325193", value: "Ethyl Alcohol Manufacturing" },
  {
    label: "325194",
    value: "Cyclic Crude, Intermediate, and Gum and Wood Chemical Manufacturing",
  },
  { label: "325199", value: "All Other Basic Organic Chemical Manufacturing" },
  { label: "325211", value: "Plastics Material and Resin Manufacturing" },
  { label: "325212", value: "Synthetic Rubber Manufacturing" },
  {
    label: "325220",
    value: "Artificial and Synthetic Fibers and Filaments Manufacturing",
  },
  { label: "325311", value: "Nitrogenous Fertilizer Manufacturing" },
  { label: "325312", value: "Phosphatic Fertilizer Manufacturing" },
  { label: "325314", value: "Fertilizer (Mixing Only) Manufacturing" },
  { label: "325315", value: "Compost Manufacturing" },
  { label: "325320", value: "Pesticide and Other Agricultural Chemical Manufacturing" },
  { label: "325411", value: "Medicinal and Botanical Manufacturing" },
  { label: "325412", value: "Pharmaceutical Preparation Manufacturing" },
  { label: "325413", value: "In-Vitro Diagnostic Substance Manufacturing" },
  { label: "325414", value: "Biological Product (except Diagnostic) Manufacturing" },
  { label: "325510", value: "Paint and Coating Manufacturing" },
  { label: "325520", value: "Adhesive Manufacturing" },
  { label: "325611", value: "Soap and Other Detergent Manufacturing" },
  { label: "325612", value: "Polish and Other Sanitation Good Manufacturing" },
  { label: "325613", value: "Surface Active Agent Manufacturing" },
  { label: "325620", value: "Toilet Preparation Manufacturing" },
  { label: "325910", value: "Printing Ink Manufacturing" },
  { label: "325920", value: "Explosives Manufacturing" },
  { label: "325991", value: "Custom Compounding of Purchased Resins" },
  {
    label: "325992",
    value: "Photographic Film, Paper, Plate, Chemical, and Copy Toner Manufacturing",
  },
  {
    label: "325998",
    value: "All Other Miscellaneous Chemical Product and Preparation Manufacturing",
  },
  { label: "326111", value: "Plastics Bag and Pouch Manufacturing" },
  {
    label: "326112",
    value: "Plastics Packaging Film and Sheet (including Laminated) Manufacturing",
  },
  {
    label: "326113",
    value: "Unlaminated Plastics Film and Sheet (except Packaging) Manufacturing",
  },
  { label: "326121", value: "Unlaminated Plastics Profile Shape Manufacturing" },
  { label: "326122", value: "Plastics Pipe and Pipe Fitting Manufacturing" },
  {
    label: "326130",
    value: "Laminated Plastics Plate, Sheet (except Packaging), and Shape Manufacturing",
  },
  { label: "326140", value: "Polystyrene Foam Product Manufacturing" },
  {
    label: "326150",
    value: "Urethane and Other Foam Product (except Polystyrene) Manufacturing",
  },
  { label: "326160", value: "Plastics Bottle Manufacturing" },
  { label: "326191", value: "Plastics Plumbing Fixture Manufacturing" },
  { label: "326199", value: "All Other Plastics Product Manufacturing" },
  { label: "326211", value: "Tire Manufacturing (except Retreading)" },
  { label: "326212", value: "Tire Retreading" },
  { label: "326220", value: "Rubber and Plastics Hoses and Belting Manufacturing" },
  { label: "326291", value: "Rubber Product Manufacturing for Mechanical Use" },
  { label: "326299", value: "All Other Rubber Product Manufacturing" },
  { label: "327110", value: "Pottery, Ceramics, and Plumbing Fixture Manufacturing" },
  { label: "327120", value: "Clay Building Material and Refractories Manufacturing" },
  { label: "327211", value: "Flat Glass Manufacturing" },
  { label: "327212", value: "Other Pressed and Blown Glass and Glassware Manufacturing" },
  { label: "327213", value: "Glass Container Manufacturing" },
  { label: "327215", value: "Glass Product Manufacturing Made of Purchased Glass" },
  { label: "327310", value: "Cement Manufacturing" },
  { label: "327320", value: "Ready-Mix Concrete Manufacturing" },
  { label: "327331", value: "Concrete Block and Brick Manufacturing" },
  { label: "327332", value: "Concrete Pipe Manufacturing" },
  { label: "327390", value: "Other Concrete Product Manufacturing" },
  { label: "327410", value: "Lime Manufacturing" },
  { label: "327420", value: "Gypsum Product Manufacturing" },
  { label: "327910", value: "Abrasive Product Manufacturing" },
  { label: "327991", value: "Cut Stone and Stone Product Manufacturing" },
  { label: "327992", value: "Ground or Treated Mineral and Earth Manufacturing" },
  { label: "327993", value: "Mineral Wool Manufacturing" },
  {
    label: "327999",
    value: "All Other Miscellaneous Nonmetallic Mineral Product Manufacturing",
  },
  { label: "331110", value: "Iron and Steel Mills and Ferroalloy Manufacturing" },
  {
    label: "331210",
    value: "Iron and Steel Pipe and Tube Manufacturing from Purchased Steel",
  },
  { label: "331221", value: "Rolled Steel Shape Manufacturing" },
  { label: "331222", value: "Steel Wire Drawing" },
  { label: "331313", value: "Alumina Refining and Primary Aluminum Production" },
  { label: "331314", value: "Secondary Smelting and Alloying of Aluminum" },
  { label: "331315", value: "Aluminum Sheet, Plate, and Foil Manufacturing" },
  { label: "331318", value: "Other Aluminum Rolling, Drawing, and Extruding" },
  { label: "331410", value: "Nonferrous Metal (except Aluminum) Smelting and Refining" },
  { label: "331420", value: "Copper Rolling, Drawing, Extruding, and Alloying" },
  {
    label: "331491",
    value:
      "Nonferrous Metal (except Copper and Aluminum) Rolling, Drawing, and Extruding",
  },
  {
    label: "331492",
    value:
      "Secondary Smelting, Refining, and Alloying of Nonferrous Metal (except Copper and Aluminum)",
  },
  { label: "331511", value: "Iron Foundries" },
  { label: "331512", value: "Steel Investment Foundries" },
  { label: "331513", value: "Steel Foundries (except Investment)" },
  { label: "331523", value: "Nonferrous Metal Die-Casting Foundries" },
  { label: "331524", value: "Aluminum Foundries (except Die-Casting)" },
  { label: "331529", value: "Other Nonferrous Metal Foundries (except Die-Casting)" },
  { label: "332111", value: "Iron and Steel Forging" },
  { label: "332112", value: "Nonferrous Forging" },
  { label: "332114", value: "Custom Roll Forming" },
  { label: "332117", value: "Powder Metallurgy Part Manufacturing" },
  {
    label: "332119",
    value: "Metal Crown, Closure, and Other Metal Stamping (except Automotive)",
  },
  {
    label: "332215",
    value:
      "Metal Kitchen Cookware, Utensil, Cutlery, and Flatware (except Precious) Manufacturing",
  },
  { label: "332216", value: "Saw Blade and Handtool Manufacturing" },
  { label: "332311", value: "Prefabricated Metal Building and Component Manufacturing" },
  { label: "332312", value: "Fabricated Structural Metal Manufacturing" },
  { label: "332313", value: "Plate Work Manufacturing" },
  { label: "332321", value: "Metal Window and Door Manufacturing" },
  { label: "332322", value: "Sheet Metal Work Manufacturing" },
  { label: "332323", value: "Ornamental and Architectural Metal Work Manufacturing" },
  { label: "332410", value: "Power Boiler and Heat Exchanger Manufacturing" },
  { label: "332420", value: "Metal Tank (Heavy Gauge) Manufacturing" },
  { label: "332431", value: "Metal Can Manufacturing" },
  { label: "332439", value: "Other Metal Container Manufacturing" },
  { label: "332510", value: "Hardware Manufacturing" },
  { label: "332613", value: "Spring Manufacturing" },
  { label: "332618", value: "Other Fabricated Wire Product Manufacturing" },
  { label: "332710", value: "Machine Shops" },
  { label: "332721", value: "Precision Turned Product Manufacturing" },
  { label: "332722", value: "Bolt, Nut, Screw, Rivet, and Washer Manufacturing" },
  { label: "332811", value: "Metal Heat Treating" },
  {
    label: "332812",
    value:
      "Metal Coating, Engraving (except Jewelry and Silverware), and Allied Services to Manufacturers",
  },
  {
    label: "332813",
    value: "Electroplating, Plating, Polishing, Anodizing, and Coloring",
  },
  { label: "332911", value: "Industrial Valve Manufacturing" },
  { label: "332912", value: "Fluid Power Valve and Hose Fitting Manufacturing" },
  { label: "332913", value: "Plumbing Fixture Fitting and Trim Manufacturing" },
  { label: "332919", value: "Other Metal Valve and Pipe Fitting Manufacturing" },
  { label: "332991", value: "Ball and Roller Bearing Manufacturing" },
  { label: "332992", value: "Small Arms Ammunition Manufacturing" },
  { label: "332993", value: "Ammunition (except Small Arms) Manufacturing" },
  {
    label: "332994",
    value: "Small Arms, Ordnance, and Ordnance Accessories Manufacturing",
  },
  { label: "332996", value: "Fabricated Pipe and Pipe Fitting Manufacturing" },
  {
    label: "332999",
    value: "All Other Miscellaneous Fabricated Metal Product Manufacturing",
  },
  { label: "333111", value: "Farm Machinery and Equipment Manufacturing" },
  {
    label: "333112",
    value: "Lawn and Garden Tractor and Home Lawn and Garden Equipment Manufacturing",
  },
  { label: "333120", value: "Construction Machinery Manufacturing" },
  { label: "333131", value: "Mining Machinery and Equipment Manufacturing" },
  { label: "333132", value: "Oil and Gas Field Machinery and Equipment Manufacturing" },
  { label: "333241", value: "Food Product Machinery Manufacturing" },
  { label: "333242", value: "Semiconductor Machinery Manufacturing" },
  { label: "333243", value: "Sawmill, Woodworking, and Paper Machinery Manufacturing" },
  { label: "333248", value: "All Other Industrial Machinery Manufacturing" },
  { label: "333310", value: "Commercial and Service Industry Machinery Manufacturing" },
  {
    label: "333413",
    value:
      "Industrial and Commercial Fan and Blower and Air Purification Equipment Manufacturing",
  },
  {
    label: "333414",
    value: "Heating Equipment (except Warm Air Furnaces) Manufacturing",
  },
  {
    label: "333415",
    value:
      "Air-Conditioning and Warm Air Heating Equipment and Commercial and Industrial Refrigeration Equipment Manufacturing",
  },
  { label: "333511", value: "Industrial Mold Manufacturing" },
  {
    label: "333514",
    value: "Special Die and Tool, Die Set, Jig, and Fixture Manufacturing",
  },
  { label: "333515", value: "Cutting Tool and Machine Tool Accessory Manufacturing" },
  { label: "333517", value: "Machine Tool Manufacturing" },
  {
    label: "333519",
    value: "Rolling Mill and Other Metalworking Machinery Manufacturing",
  },
  { label: "333611", value: "Turbine and Turbine Generator Set Units Manufacturing" },
  {
    label: "333612",
    value: "Speed Changer, Industrial High-Speed Drive, and Gear Manufacturing",
  },
  { label: "333613", value: "Mechanical Power Transmission Equipment Manufacturing" },
  { label: "333618", value: "Other Engine Equipment Manufacturing" },
  { label: "333912", value: "Air and Gas Compressor Manufacturing" },
  {
    label: "333914",
    value: "Measuring, Dispensing, and Other Pumping Equipment Manufacturing",
  },
  { label: "333921", value: "Elevator and Moving Stairway Manufacturing" },
  { label: "333922", value: "Conveyor and Conveying Equipment Manufacturing" },
  {
    label: "333923",
    value: "Overhead Traveling Crane, Hoist, and Monorail System Manufacturing",
  },
  {
    label: "333924",
    value: "Industrial Truck, Tractor, Trailer, and Stacker Machinery Manufacturing",
  },
  { label: "333991", value: "Power-Driven Handtool Manufacturing" },
  { label: "333992", value: "Welding and Soldering Equipment Manufacturing" },
  { label: "333993", value: "Packaging Machinery Manufacturing" },
  { label: "333994", value: "Industrial Process Furnace and Oven Manufacturing" },
  { label: "333995", value: "Fluid Power Cylinder and Actuator Manufacturing" },
  { label: "333996", value: "Fluid Power Pump and Motor Manufacturing" },
  {
    label: "333998",
    value: "All Other Miscellaneous General Purpose Machinery Manufacturing",
  },
  { label: "334111", value: "Electronic Computer Manufacturing" },
  { label: "334112", value: "Computer Storage Device Manufacturing" },
  {
    label: "334118",
    value: "Computer Terminal and Other Computer Peripheral Equipment Manufacturing",
  },
  { label: "334210", value: "Telephone Apparatus Manufacturing" },
  {
    label: "334220",
    value:
      "Radio and Television Broadcasting and Wireless Communications Equipment Manufacturing",
  },
  { label: "334290", value: "Other Communications Equipment Manufacturing" },
  { label: "334310", value: "Audio and Video Equipment Manufacturing" },
  { label: "334412", value: "Bare Printed Circuit Board Manufacturing" },
  { label: "334413", value: "Semiconductor and Related Device Manufacturing" },
  {
    label: "334416",
    value: "Capacitor, Resistor, Coil, Transformer, and Other Inductor Manufacturing",
  },
  { label: "334417", value: "Electronic Connector Manufacturing" },
  {
    label: "334418",
    value: "Printed Circuit Assembly (Electronic Assembly) Manufacturing",
  },
  { label: "334419", value: "Other Electronic Component Manufacturing" },
  {
    label: "334510",
    value: "Electromedical and Electrotherapeutic Apparatus Manufacturing",
  },
  {
    label: "334511",
    value:
      "Search, Detection, Navigation, Guidance, Aeronautical, and Nautical System and Instrument Manufacturing",
  },
  {
    label: "334512",
    value:
      "Automatic Environmental Control Manufacturing for Residential, Commercial, and Appliance Use",
  },
  {
    label: "334513",
    value:
      "Instruments and Related Products Manufacturing for Measuring, Displaying, and Controlling Industrial Process Variables",
  },
  { label: "334514", value: "Totalizing Fluid Meter and Counting Device Manufacturing" },
  {
    label: "334515",
    value:
      "Instrument Manufacturing for Measuring and Testing Electricity and Electrical Signals",
  },
  { label: "334516", value: "Analytical Laboratory Instrument Manufacturing" },
  { label: "334517", value: "Irradiation Apparatus Manufacturing" },
  { label: "334519", value: "Other Measuring and Controlling Device Manufacturing" },
  { label: "334610", value: "Manufacturing and Reproducing Magnetic and Optical Media" },
  { label: "335131", value: "Residential Electric Lighting Fixture Manufacturing" },
  {
    label: "335132",
    value:
      "Commercial, Industrial, and Institutional Electric Lighting Fixture Manufacturing",
  },
  {
    label: "335139",
    value: "Electric Lamp Bulb and Other Lighting Equipment Manufacturing",
  },
  { label: "335210", value: "Small Electrical Appliance Manufacturing" },
  { label: "335220", value: "Major Household Appliance Manufacturing" },
  {
    label: "335311",
    value: "Power, Distribution, and Specialty Transformer Manufacturing",
  },
  { label: "335312", value: "Motor and Generator Manufacturing" },
  { label: "335313", value: "Switchgear and Switchboard Apparatus Manufacturing" },
  { label: "335314", value: "Relay and Industrial Control Manufacturing" },
  { label: "335910", value: "Battery Manufacturing" },
  { label: "335921", value: "Fiber Optic Cable Manufacturing" },
  { label: "335929", value: "Other Communication and Energy Wire Manufacturing" },
  { label: "335931", value: "Current-Carrying Wiring Device Manufacturing" },
  { label: "335932", value: "Noncurrent-Carrying Wiring Device Manufacturing" },
  { label: "335991", value: "Carbon and Graphite Product Manufacturing" },
  {
    label: "335999",
    value: "All Other Miscellaneous Electrical Equipment and Component Manufacturing",
  },
  { label: "336110", value: "Automobile and Light Duty Motor Vehicle Manufacturing" },
  { label: "336120", value: "Heavy Duty Truck Manufacturing" },
  { label: "336211", value: "Motor Vehicle Body Manufacturing" },
  { label: "336212", value: "Truck Trailer Manufacturing" },
  { label: "336213", value: "Motor Home Manufacturing" },
  { label: "336214", value: "Travel Trailer and Camper Manufacturing" },
  {
    label: "336310",
    value: "Motor Vehicle Gasoline Engine and Engine Parts Manufacturing",
  },
  {
    label: "336320",
    value: "Motor Vehicle Electrical and Electronic Equipment Manufacturing",
  },
  {
    label: "336330",
    value:
      "Motor Vehicle Steering and Suspension Components (except Spring) Manufacturing",
  },
  { label: "336340", value: "Motor Vehicle Brake System Manufacturing" },
  {
    label: "336350",
    value: "Motor Vehicle Transmission and Power Train Parts Manufacturing",
  },
  { label: "336360", value: "Motor Vehicle Seating and Interior Trim Manufacturing" },
  { label: "336370", value: "Motor Vehicle Metal Stamping" },
  { label: "336390", value: "Other Motor Vehicle Parts Manufacturing" },
  { label: "336411", value: "Aircraft Manufacturing" },
  { label: "336412", value: "Aircraft Engine and Engine Parts Manufacturing" },
  {
    label: "336413",
    value: "Other Aircraft Parts and Auxiliary Equipment Manufacturing",
  },
  { label: "336414", value: "Guided Missile and Space Vehicle Manufacturing" },
  {
    label: "336415",
    value:
      "Guided Missile and Space Vehicle Propulsion Unit and Propulsion Unit Parts Manufacturing",
  },
  {
    label: "336419",
    value:
      "Other Guided Missile and Space Vehicle Parts and Auxiliary Equipment Manufacturing",
  },
  { label: "336510", value: "Railroad Rolling Stock Manufacturing" },
  { label: "336611", value: "Ship Building and Repairing" },
  { label: "336612", value: "Boat Building" },
  { label: "336991", value: "Motorcycle, Bicycle, and Parts Manufacturing" },
  {
    label: "336992",
    value: "Military Armored Vehicle, Tank, and Tank Component Manufacturing",
  },
  { label: "336999", value: "All Other Transportation Equipment Manufacturing" },
  { label: "337110", value: "Wood Kitchen Cabinet and Countertop Manufacturing" },
  { label: "337121", value: "Upholstered Household Furniture Manufacturing" },
  { label: "337122", value: "Nonupholstered Wood Household Furniture Manufacturing" },
  {
    label: "337126",
    value: "Household Furniture (except Wood and Upholstered) Manufacturing",
  },
  { label: "337127", value: "Institutional Furniture Manufacturing" },
  { label: "337211", value: "Wood Office Furniture Manufacturing" },
  { label: "337212", value: "Custom Architectural Woodwork and Millwork Manufacturing" },
  { label: "337214", value: "Office Furniture (except Wood) Manufacturing" },
  { label: "337215", value: "Showcase, Partition, Shelving, and Locker Manufacturing" },
  { label: "337910", value: "Mattress Manufacturing" },
  { label: "337920", value: "Blind and Shade Manufacturing" },
  { label: "339112", value: "Surgical and Medical Instrument Manufacturing" },
  { label: "339113", value: "Surgical Appliance and Supplies Manufacturing" },
  { label: "339114", value: "Dental Equipment and Supplies Manufacturing" },
  { label: "339115", value: "Ophthalmic Goods Manufacturing" },
  { label: "339116", value: "Dental Laboratories" },
  { label: "339910", value: "Jewelry and Silverware Manufacturing" },
  { label: "339920", value: "Sporting and Athletic Goods Manufacturing" },
  { label: "339930", value: "Doll, Toy, and Game Manufacturing" },
  { label: "339940", value: "Office Supplies (except Paper) Manufacturing" },
  { label: "339950", value: "Sign Manufacturing" },
  { label: "339991", value: "Gasket, Packing, and Sealing Device Manufacturing" },
  { label: "339992", value: "Musical Instrument Manufacturing" },
  { label: "339993", value: "Fastener, Button, Needle, and Pin Manufacturing" },
  { label: "339994", value: "Broom, Brush, and Mop Manufacturing" },
  { label: "339995", value: "Burial Casket Manufacturing" },
  { label: "339999", value: "All Other Miscellaneous Manufacturing" },
  { label: "3111", value: "Animal Food Manufacturing" },
  { label: "311111", value: "Dog and Cat Food Manufacturing" },
  { label: "311119", value: "Other Animal Food Manufacturing" },
  { label: "3112", value: "Grain and Oilseed Milling" },
  { label: "311211", value: "Flour Milling" },
  { label: "311212", value: "Rice Milling" },
  { label: "311213", value: "Malt Manufacturing" },
  { label: "311221", value: "Wet Corn Milling and Starch Manufacturing" },
  { label: "311224", value: "Soybean and Other Oilseed Processing" },
  { label: "311225", value: "Fats and Oils Refining and Blending" },
  { label: "311230", value: "Breakfast Cereal Manufacturing" },
  { label: "3113", value: "Sugar and Confectionery Product Manufacturing" },
  { label: "311313", value: "Beet Sugar Manufacturing" },
  { label: "311314", value: "Cane Sugar Manufacturing" },
  { label: "311340", value: "Nonchocolate Confectionery Manufacturing" },
  {
    label: "311351",
    value: "Chocolate and Confectionery Manufacturing from Cacao Beans",
  },
  { label: "311352", value: "Confectionery Manufacturing from Purchased Chocolate" },
  {
    label: "3114",
    value: "Fruit and Vegetable Preserving and Specialty Food Manufacturing",
  },
  { label: "311411", value: "Frozen Fruit, Juice, and Vegetable Manufacturing" },
  { label: "311412", value: "Frozen Specialty Food Manufacturing" },
  { label: "311421", value: "Fruit and Vegetable Canning" },
  { label: "311422", value: "Specialty Canning" },
  { label: "311423", value: "Dried and Dehydrated Food Manufacturing" },
  { label: "3115", value: "Dairy Product Manufacturing" },
  { label: "311511", value: "Fluid Milk Manufacturing" },
  { label: "311512", value: "Creamery Butter Manufacturing" },
  { label: "311513", value: "Cheese Manufacturing" },
  {
    label: "311514",
    value: "Dry, Condensed, and Evaporated Dairy Product Manufacturing",
  },
  { label: "311520", value: "Ice Cream and Frozen Dessert Manufacturing" },
  { label: "3116", value: "Animal Slaughtering and Processing" },
  { label: "311611", value: "Animal (except Poultry) Slaughtering" },
  { label: "311612", value: "Meat Processed from Carcasses" },
  { label: "311613", value: "Rendering and Meat Byproduct Processing" },
  { label: "311615", value: "Poultry Processing" },
  { label: "3117", value: "Seafood Product Preparation and Packaging" },
  { label: "311710", value: "Seafood Product Preparation and Packaging" },
  { label: "3118", value: "Bakeries and Tortilla Manufacturing" },
  { label: "311811", value: "Retail Bakeries" },
  { label: "311812", value: "Commercial Bakeries" },
  { label: "311813", value: "Frozen Cakes, Pies, and Other Pastries Manufacturing" },
  { label: "311821", value: "Cookie and Cracker Manufacturing" },
  {
    label: "311824",
    value: "Dry Pasta, Dough, and Flour Mixes Manufacturing from Purchased Flour",
  },
  { label: "311830", value: "Tortilla Manufacturing" },
  { label: "3119", value: "Other Food Manufacturing" },
  { label: "311911", value: "Roasted Nuts and Peanut Butter Manufacturing" },
  { label: "311919", value: "Other Snack Food Manufacturing" },
  { label: "311920", value: "Coffee and Tea Manufacturing" },
  { label: "311930", value: "Flavoring Syrup and Concentrate Manufacturing" },
  {
    label: "311941",
    value: "Mayonnaise, Dressing, and Other Prepared Sauce Manufacturing",
  },
  { label: "311942", value: "Spice and Extract Manufacturing" },
  { label: "311991", value: "Perishable Prepared Food Manufacturing" },
  { label: "311999", value: "All Other Miscellaneous Food Manufacturing" },
  { label: "3121", value: "Beverage Manufacturing" },
  { label: "312111", value: "Soft Drink Manufacturing" },
  { label: "312112", value: "Bottled Water Manufacturing" },
  { label: "312113", value: "Ice Manufacturing" },
  { label: "312120", value: "Breweries" },
  { label: "312130", value: "Wineries" },
  { label: "312140", value: "Distilleries" },
  { label: "3122", value: "Tobacco Manufacturing" },
  { label: "312230", value: "Tobacco Manufacturing" },
  { label: "3131", value: "Fiber, Yarn, and Thread Mills" },
  { label: "313110", value: "Fiber, Yarn, and Thread Mills" },
  { label: "3132", value: "Fabric Mills" },
  { label: "313210", value: "Broadwoven Fabric Mills" },
  { label: "313220", value: "Narrow Fabric Mills and Schiffli Machine Embroidery" },
  { label: "313230", value: "Nonwoven Fabric Mills" },
  { label: "313240", value: "Knit Fabric Mills" },
  { label: "3133", value: "Textile and Fabric Finishing and Fabric Coating Mills" },
  { label: "313310", value: "Textile and Fabric Finishing Mills" },
  { label: "313320", value: "Fabric Coating Mills" },
  { label: "3141", value: "Textile Furnishings Mills" },
  { label: "314110", value: "Carpet and Rug Mills" },
  { label: "314120", value: "Curtain and Linen Mills" },
  { label: "3149", value: "Other Textile Product Mills" },
  { label: "314910", value: "Textile Bag and Canvas Mills" },
  { label: "314994", value: "Rope, Cordage, Twine, Tire Cord, and Tire Fabric Mills" },
  { label: "314999", value: "All Other Miscellaneous Textile Product Mills" },
  { label: "3151", value: "Apparel Knitting Mills" },
  { label: "315120", value: "Apparel Knitting Mills" },
  { label: "3152", value: "Cut and Sew Apparel Manufacturing" },
  { label: "315210", value: "Cut and Sew Apparel Contractors" },
  { label: "315250", value: "Cut and Sew Apparel Manufacturing (except Contractors)" },
  { label: "3159", value: "Apparel Accessories and Other Apparel Manufacturing" },
  { label: "315990", value: "Apparel Accessories and Other Apparel Manufacturing" },
  { label: "3161", value: "Leather and Hide Tanning and Finishing" },
  { label: "316110", value: "Leather and Hide Tanning and Finishing" },
  { label: "3162", value: "Footwear Manufacturing" },
  { label: "316210", value: "Footwear Manufacturing" },
  { label: "3169", value: "Other Leather and Allied Product Manufacturing" },
  { label: "316990", value: "Other Leather and Allied Product Manufacturing" },
  { label: "3211", value: "Sawmills and Wood Preservation" },
  { label: "321113", value: "Sawmills" },
  { label: "321114", value: "Wood Preservation" },
  { label: "3212", value: "Veneer, Plywood, and Engineered Wood Product Manufacturing" },
  { label: "321211", value: "Hardwood Veneer and Plywood Manufacturing" },
  { label: "321212", value: "Softwood Veneer and Plywood Manufacturing" },
  { label: "321215", value: "Engineered Wood Member Manufacturing" },
  { label: "321219", value: "Reconstituted Wood Product Manufacturing" },
  { label: "3219", value: "Other Wood Product Manufacturing" },
  { label: "321911", value: "Wood Window and Door Manufacturing" },
  { label: "321912", value: "Cut Stock, Resawing Lumber, and Planing" },
  { label: "321918", value: "Other Millwork (including Flooring)" },
  { label: "321920", value: "Wood Container and Pallet Manufacturing" },
  { label: "321991", value: "Manufactured Home (Mobile Home) Manufacturing" },
  { label: "321992", value: "Prefabricated Wood Building Manufacturing" },
  { label: "321999", value: "All Other Miscellaneous Wood Product Manufacturing" },
  { label: "3221", value: "Pulp, Paper, and Paperboard Mills" },
  { label: "322110", value: "Pulp Mills" },
  { label: "322120", value: "Paper Mills" },
  { label: "322130", value: "Paperboard Mills" },
  { label: "3222", value: "Converted Paper Product Manufacturing" },
  { label: "322211", value: "Corrugated and Solid Fiber Box Manufacturing" },
  { label: "322212", value: "Folding Paperboard Box Manufacturing" },
  { label: "322219", value: "Other Paperboard Container Manufacturing" },
  { label: "322220", value: "Paper Bag and Coated and Treated Paper Manufacturing" },
  { label: "322230", value: "Stationery Product Manufacturing" },
  { label: "322291", value: "Sanitary Paper Product Manufacturing" },
  { label: "322299", value: "All Other Converted Paper Product Manufacturing" },
  { label: "3231", value: "Printing and Related Support Activities" },
  { label: "323111", value: "Commercial Printing (except Screen and Books)" },
  { label: "323113", value: "Commercial Screen Printing" },
  { label: "323117", value: "Books Printing" },
  { label: "323120", value: "Support Activities for Printing" },
  { label: "3241", value: "Petroleum and Coal Products Manufacturing" },
  { label: "324110", value: "Petroleum Refineries" },
  { label: "324121", value: "Asphalt Paving Mixture and Block Manufacturing" },
  { label: "324122", value: "Asphalt Shingle and Coating Materials Manufacturing" },
  { label: "324191", value: "Petroleum Lubricating Oil and Grease Manufacturing" },
  { label: "324199", value: "All Other Petroleum and Coal Products Manufacturing" },
  { label: "3251", value: "Basic Chemical Manufacturing" },
  { label: "325110", value: "Petrochemical Manufacturing" },
  { label: "325120", value: "Industrial Gas Manufacturing" },
  { label: "325130", value: "Synthetic Dye and Pigment Manufacturing" },
  { label: "325180", value: "Other Basic Inorganic Chemical Manufacturing" },
  { label: "325193", value: "Ethyl Alcohol Manufacturing" },
  {
    label: "325194",
    value: "Cyclic Crude, Intermediate, and Gum and Wood Chemical Manufacturing",
  },
  { label: "325199", value: "All Other Basic Organic Chemical Manufacturing" },
  {
    label: "3252",
    value:
      "Resin, Synthetic Rubber, and Artificial and Synthetic Fibers and Filaments Manufacturing",
  },
  { label: "325211", value: "Plastics Material and Resin Manufacturing" },
  { label: "325212", value: "Synthetic Rubber Manufacturing" },
  {
    label: "325220",
    value: "Artificial and Synthetic Fibers and Filaments Manufacturing",
  },
  {
    label: "3253",
    value: "Pesticide, Fertilizer, and Other Agricultural Chemical Manufacturing",
  },
  { label: "325311", value: "Nitrogenous Fertilizer Manufacturing" },
  { label: "325312", value: "Phosphatic Fertilizer Manufacturing" },
  { label: "325314", value: "Fertilizer (Mixing Only) Manufacturing" },
  { label: "325315", value: "Compost Manufacturing" },
  { label: "325320", value: "Pesticide and Other Agricultural Chemical Manufacturing" },
  { label: "3254", value: "Pharmaceutical and Medicine Manufacturing" },
  { label: "325411", value: "Medicinal and Botanical Manufacturing" },
  { label: "325412", value: "Pharmaceutical Preparation Manufacturing" },
  { label: "325413", value: "In-Vitro Diagnostic Substance Manufacturing" },
  { label: "325414", value: "Biological Product (except Diagnostic) Manufacturing" },
  { label: "3255", value: "Paint, Coating, and Adhesive Manufacturing" },
  { label: "325510", value: "Paint and Coating Manufacturing" },
  { label: "325520", value: "Adhesive Manufacturing" },
  {
    label: "3256",
    value: "Soap, Cleaning Compound, and Toilet Preparation Manufacturing",
  },
  { label: "325611", value: "Soap and Other Detergent Manufacturing" },
  { label: "325612", value: "Polish and Other Sanitation Good Manufacturing" },
  { label: "325613", value: "Surface Active Agent Manufacturing" },
  { label: "325620", value: "Toilet Preparation Manufacturing" },
  { label: "3259", value: "Other Chemical Product and Preparation Manufacturing" },
  { label: "325910", value: "Printing Ink Manufacturing" },
  { label: "325920", value: "Explosives Manufacturing" },
  { label: "325991", value: "Custom Compounding of Purchased Resins" },
  {
    label: "325992",
    value: "Photographic Film, Paper, Plate, Chemical, and Copy Toner Manufacturing",
  },
  {
    label: "325998",
    value: "All Other Miscellaneous Chemical Product and Preparation Manufacturing",
  },
  { label: "3261", value: "Plastics Product Manufacturing" },
  { label: "326111", value: "Plastics Bag and Pouch Manufacturing" },
  {
    label: "326112",
    value: "Plastics Packaging Film and Sheet (including Laminated) Manufacturing",
  },
  {
    label: "326113",
    value: "Unlaminated Plastics Film and Sheet (except Packaging) Manufacturing",
  },
  { label: "326121", value: "Unlaminated Plastics Profile Shape Manufacturing" },
  { label: "326122", value: "Plastics Pipe and Pipe Fitting Manufacturing" },
  {
    label: "326130",
    value: "Laminated Plastics Plate, Sheet (except Packaging), and Shape Manufacturing",
  },
  { label: "326140", value: "Polystyrene Foam Product Manufacturing" },
  {
    label: "326150",
    value: "Urethane and Other Foam Product (except Polystyrene) Manufacturing",
  },
  { label: "326160", value: "Plastics Bottle Manufacturing" },
  { label: "326191", value: "Plastics Plumbing Fixture Manufacturing" },
  { label: "326199", value: "All Other Plastics Product Manufacturing" },
  { label: "3262", value: "Rubber Product Manufacturing" },
  { label: "326211", value: "Tire Manufacturing (except Retreading)" },
  { label: "326212", value: "Tire Retreading" },
  { label: "326220", value: "Rubber and Plastics Hoses and Belting Manufacturing" },
  { label: "326291", value: "Rubber Product Manufacturing for Mechanical Use" },
  { label: "326299", value: "All Other Rubber Product Manufacturing" },
  { label: "3271", value: "Clay Product and Refractory Manufacturing" },
  { label: "327110", value: "Pottery, Ceramics, and Plumbing Fixture Manufacturing" },
  { label: "327120", value: "Clay Building Material and Refractories Manufacturing" },
  { label: "3272", value: "Glass and Glass Product Manufacturing" },
  { label: "327211", value: "Flat Glass Manufacturing" },
  { label: "327212", value: "Other Pressed and Blown Glass and Glassware Manufacturing" },
  { label: "327213", value: "Glass Container Manufacturing" },
  { label: "327215", value: "Glass Product Manufacturing Made of Purchased Glass" },
  { label: "3273", value: "Cement and Concrete Product Manufacturing" },
  { label: "327310", value: "Cement Manufacturing" },
  { label: "327320", value: "Ready-Mix Concrete Manufacturing" },
  { label: "327331", value: "Concrete Block and Brick Manufacturing" },
  { label: "327332", value: "Concrete Pipe Manufacturing" },
  { label: "327390", value: "Other Concrete Product Manufacturing" },
  { label: "3274", value: "Lime and Gypsum Product Manufacturing" },
  { label: "327410", value: "Lime Manufacturing" },
  { label: "327420", value: "Gypsum Product Manufacturing" },
  { label: "3279", value: "Other Nonmetallic Mineral Product Manufacturing" },
  { label: "327910", value: "Abrasive Product Manufacturing" },
  { label: "327991", value: "Cut Stone and Stone Product Manufacturing" },
  { label: "327992", value: "Ground or Treated Mineral and Earth Manufacturing" },
  { label: "327993", value: "Mineral Wool Manufacturing" },
  {
    label: "327999",
    value: "All Other Miscellaneous Nonmetallic Mineral Product Manufacturing",
  },
  { label: "3311", value: "Iron and Steel Mills and Ferroalloy Manufacturing" },
  { label: "331110", value: "Iron and Steel Mills and Ferroalloy Manufacturing" },
  { label: "3312", value: "Steel Product Manufacturing from Purchased Steel" },
  {
    label: "331210",
    value: "Iron and Steel Pipe and Tube Manufacturing from Purchased Steel",
  },
  { label: "331221", value: "Rolled Steel Shape Manufacturing" },
  { label: "331222", value: "Steel Wire Drawing" },
  { label: "3313", value: "Alumina and Aluminum Production and Processing" },
  { label: "331313", value: "Alumina Refining and Primary Aluminum Production" },
  { label: "331314", value: "Secondary Smelting and Alloying of Aluminum" },
  { label: "331315", value: "Aluminum Sheet, Plate, and Foil Manufacturing" },
  { label: "331318", value: "Other Aluminum Rolling, Drawing, and Extruding" },
  {
    label: "3314",
    value: "Nonferrous Metal (except Aluminum) Production and Processing",
  },
  { label: "331410", value: "Nonferrous Metal (except Aluminum) Smelting and Refining" },
  { label: "331420", value: "Copper Rolling, Drawing, Extruding, and Alloying" },
  {
    label: "331491",
    value:
      "Nonferrous Metal (except Copper and Aluminum) Rolling, Drawing, and Extruding",
  },
  {
    label: "331492",
    value:
      "Secondary Smelting, Refining, and Alloying of Nonferrous Metal (except Copper and Aluminum)",
  },
  { label: "3315", value: "Foundries" },
  { label: "331511", value: "Iron Foundries" },
  { label: "331512", value: "Steel Investment Foundries" },
  { label: "331513", value: "Steel Foundries (except Investment)" },
  { label: "331523", value: "Nonferrous Metal Die-Casting Foundries" },
  { label: "331524", value: "Aluminum Foundries (except Die-Casting)" },
  { label: "331529", value: "Other Nonferrous Metal Foundries (except Die-Casting)" },
  { label: "3321", value: "Forging and Stamping" },
  { label: "332111", value: "Iron and Steel Forging" },
  { label: "332112", value: "Nonferrous Forging" },
  { label: "332114", value: "Custom Roll Forming" },
  { label: "332117", value: "Powder Metallurgy Part Manufacturing" },
  {
    label: "332119",
    value: "Metal Crown, Closure, and Other Metal Stamping (except Automotive)",
  },
  { label: "3322", value: "Cutlery and Handtool Manufacturing" },
  {
    label: "332215",
    value:
      "Metal Kitchen Cookware, Utensil, Cutlery, and Flatware (except Precious) Manufacturing",
  },
  { label: "332216", value: "Saw Blade and Handtool Manufacturing" },
  { label: "3323", value: "Architectural and Structural Metals Manufacturing" },
  { label: "332311", value: "Prefabricated Metal Building and Component Manufacturing" },
  { label: "332312", value: "Fabricated Structural Metal Manufacturing" },
  { label: "332313", value: "Plate Work Manufacturing" },
  { label: "332321", value: "Metal Window and Door Manufacturing" },
  { label: "332322", value: "Sheet Metal Work Manufacturing" },
  { label: "332323", value: "Ornamental and Architectural Metal Work Manufacturing" },
  { label: "3324", value: "Boiler, Tank, and Shipping Container Manufacturing" },
  { label: "332410", value: "Power Boiler and Heat Exchanger Manufacturing" },
  { label: "332420", value: "Metal Tank (Heavy Gauge) Manufacturing" },
  { label: "332431", value: "Metal Can Manufacturing" },
  { label: "332439", value: "Other Metal Container Manufacturing" },
  { label: "3325", value: "Hardware Manufacturing" },
  { label: "332510", value: "Hardware Manufacturing" },
  { label: "3326", value: "Spring and Wire Product Manufacturing" },
  { label: "332613", value: "Spring Manufacturing" },
  { label: "332618", value: "Other Fabricated Wire Product Manufacturing" },
  {
    label: "3327",
    value: "Machine Shops; Turned Product; and Screw, Nut, and Bolt Manufacturing",
  },
  { label: "332710", value: "Machine Shops" },
  { label: "332721", value: "Precision Turned Product Manufacturing" },
  { label: "332722", value: "Bolt, Nut, Screw, Rivet, and Washer Manufacturing" },
  { label: "3328", value: "Coating, Engraving, Heat Treating, and Allied Activities" },
  { label: "332811", value: "Metal Heat Treating" },
  {
    label: "332812",
    value:
      "Metal Coating, Engraving (except Jewelry and Silverware), and Allied Services to Manufacturers",
  },
  {
    label: "332813",
    value: "Electroplating, Plating, Polishing, Anodizing, and Coloring",
  },
  { label: "3329", value: "Other Fabricated Metal Product Manufacturing" },
  { label: "332911", value: "Industrial Valve Manufacturing" },
  { label: "332912", value: "Fluid Power Valve and Hose Fitting Manufacturing" },
  { label: "332913", value: "Plumbing Fixture Fitting and Trim Manufacturing" },
  { label: "332919", value: "Other Metal Valve and Pipe Fitting Manufacturing" },
  { label: "332991", value: "Ball and Roller Bearing Manufacturing" },
  { label: "332992", value: "Small Arms Ammunition Manufacturing" },
  { label: "332993", value: "Ammunition (except Small Arms) Manufacturing" },
  {
    label: "332994",
    value: "Small Arms, Ordnance, and Ordnance Accessories Manufacturing",
  },
  { label: "332996", value: "Fabricated Pipe and Pipe Fitting Manufacturing" },
  {
    label: "332999",
    value: "All Other Miscellaneous Fabricated Metal Product Manufacturing",
  },
  {
    label: "3331",
    value: "Agriculture, Construction, and Mining Machinery Manufacturing",
  },
  { label: "333111", value: "Farm Machinery and Equipment Manufacturing" },
  {
    label: "333112",
    value: "Lawn and Garden Tractor and Home Lawn and Garden Equipment Manufacturing",
  },
  { label: "333120", value: "Construction Machinery Manufacturing" },
  { label: "333131", value: "Mining Machinery and Equipment Manufacturing" },
  { label: "333132", value: "Oil and Gas Field Machinery and Equipment Manufacturing" },
  { label: "3332", value: "Industrial Machinery Manufacturing" },
  { label: "333241", value: "Food Product Machinery Manufacturing" },
  { label: "333242", value: "Semiconductor Machinery Manufacturing" },
  { label: "333243", value: "Sawmill, Woodworking, and Paper Machinery Manufacturing" },
  { label: "333248", value: "All Other Industrial Machinery Manufacturing" },
  { label: "3333", value: "Commercial and Service Industry Machinery Manufacturing" },
  { label: "333310", value: "Commercial and Service Industry Machinery Manufacturing" },
  {
    label: "3334",
    value:
      "Ventilation, Heating, Air-Conditioning, and Commercial Refrigeration Equipment Manufacturing",
  },
  {
    label: "333413",
    value:
      "Industrial and Commercial Fan and Blower and Air Purification Equipment Manufacturing",
  },
  {
    label: "333414",
    value: "Heating Equipment (except Warm Air Furnaces) Manufacturing",
  },
  {
    label: "333415",
    value:
      "Air-Conditioning and Warm Air Heating Equipment and Commercial and Industrial Refrigeration Equipment Manufacturing",
  },
  { label: "3335", value: "Metalworking Machinery Manufacturing" },
  { label: "333511", value: "Industrial Mold Manufacturing" },
  {
    label: "333514",
    value: "Special Die and Tool, Die Set, Jig, and Fixture Manufacturing",
  },
  { label: "333515", value: "Cutting Tool and Machine Tool Accessory Manufacturing" },
  { label: "333517", value: "Machine Tool Manufacturing" },
  {
    label: "333519",
    value: "Rolling Mill and Other Metalworking Machinery Manufacturing",
  },
  {
    label: "3336",
    value: "Engine, Turbine, and Power Transmission Equipment Manufacturing",
  },
  { label: "333611", value: "Turbine and Turbine Generator Set Units Manufacturing" },
  {
    label: "333612",
    value: "Speed Changer, Industrial High-Speed Drive, and Gear Manufacturing",
  },
  { label: "333613", value: "Mechanical Power Transmission Equipment Manufacturing" },
  { label: "333618", value: "Other Engine Equipment Manufacturing" },
  { label: "3339", value: "Other General Purpose Machinery Manufacturing" },
  { label: "333912", value: "Air and Gas Compressor Manufacturing" },
  {
    label: "333914",
    value: "Measuring, Dispensing, and Other Pumping Equipment Manufacturing",
  },
  { label: "333921", value: "Elevator and Moving Stairway Manufacturing" },
  { label: "333922", value: "Conveyor and Conveying Equipment Manufacturing" },
  {
    label: "333923",
    value: "Overhead Traveling Crane, Hoist, and Monorail System Manufacturing",
  },
  {
    label: "333924",
    value: "Industrial Truck, Tractor, Trailer, and Stacker Machinery Manufacturing",
  },
  { label: "333991", value: "Power-Driven Handtool Manufacturing" },
  { label: "333992", value: "Welding and Soldering Equipment Manufacturing" },
  { label: "333993", value: "Packaging Machinery Manufacturing" },
  { label: "333994", value: "Industrial Process Furnace and Oven Manufacturing" },
  { label: "333995", value: "Fluid Power Cylinder and Actuator Manufacturing" },
  { label: "333996", value: "Fluid Power Pump and Motor Manufacturing" },
  {
    label: "333998",
    value: "All Other Miscellaneous General Purpose Machinery Manufacturing",
  },
  { label: "3341", value: "Computer and Peripheral Equipment Manufacturing" },
  { label: "334111", value: "Electronic Computer Manufacturing" },
  { label: "334112", value: "Computer Storage Device Manufacturing" },
  {
    label: "334118",
    value: "Computer Terminal and Other Computer Peripheral Equipment Manufacturing",
  },
  { label: "3342", value: "Communications Equipment Manufacturing" },
  { label: "334210", value: "Telephone Apparatus Manufacturing" },
  {
    label: "334220",
    value:
      "Radio and Television Broadcasting and Wireless Communications Equipment Manufacturing",
  },
  { label: "334290", value: "Other Communications Equipment Manufacturing" },
  { label: "3343", value: "Audio and Video Equipment Manufacturing" },
  { label: "334310", value: "Audio and Video Equipment Manufacturing" },
  { label: "3344", value: "Semiconductor and Other Electronic Component Manufacturing" },
  { label: "334412", value: "Bare Printed Circuit Board Manufacturing" },
  { label: "334413", value: "Semiconductor and Related Device Manufacturing" },
  {
    label: "334416",
    value: "Capacitor, Resistor, Coil, Transformer, and Other Inductor Manufacturing",
  },
  { label: "334417", value: "Electronic Connector Manufacturing" },
  {
    label: "334418",
    value: "Printed Circuit Assembly (Electronic Assembly) Manufacturing",
  },
  { label: "334419", value: "Other Electronic Component Manufacturing" },
  {
    label: "3345",
    value:
      "Navigational, Measuring, Electromedical, and Control Instruments Manufacturing",
  },
  {
    label: "334510",
    value: "Electromedical and Electrotherapeutic Apparatus Manufacturing",
  },
  {
    label: "334511",
    value:
      "Search, Detection, Navigation, Guidance, Aeronautical, and Nautical System and Instrument Manufacturing",
  },
  {
    label: "334512",
    value:
      "Automatic Environmental Control Manufacturing for Residential, Commercial, and Appliance Use",
  },
  {
    label: "334513",
    value:
      "Instruments and Related Products Manufacturing for Measuring, Displaying, and Controlling Industrial Process Variables",
  },
  { label: "334514", value: "Totalizing Fluid Meter and Counting Device Manufacturing" },
  {
    label: "334515",
    value:
      "Instrument Manufacturing for Measuring and Testing Electricity and Electrical Signals",
  },
  { label: "334516", value: "Analytical Laboratory Instrument Manufacturing" },
  { label: "334517", value: "Irradiation Apparatus Manufacturing" },
  { label: "334519", value: "Other Measuring and Controlling Device Manufacturing" },
  { label: "3346", value: "Manufacturing and Reproducing Magnetic and Optical Media" },
  { label: "334610", value: "Manufacturing and Reproducing Magnetic and Optical Media" },
  { label: "3351", value: "Electric Lighting Equipment Manufacturing" },
  { label: "335131", value: "Residential Electric Lighting Fixture Manufacturing" },
  {
    label: "335132",
    value:
      "Commercial, Industrial, and Institutional Electric Lighting Fixture Manufacturing",
  },
  {
    label: "335139",
    value: "Electric Lamp Bulb and Other Lighting Equipment Manufacturing",
  },
  { label: "3352", value: "Household Appliance Manufacturing" },
  { label: "335210", value: "Small Electrical Appliance Manufacturing" },
  { label: "335220", value: "Major Household Appliance Manufacturing" },
  { label: "3353", value: "Electrical Equipment Manufacturing" },
  {
    label: "335311",
    value: "Power, Distribution, and Specialty Transformer Manufacturing",
  },
  { label: "335312", value: "Motor and Generator Manufacturing" },
  { label: "335313", value: "Switchgear and Switchboard Apparatus Manufacturing" },
  { label: "335314", value: "Relay and Industrial Control Manufacturing" },
  { label: "3359", value: "Other Electrical Equipment and Component Manufacturing" },
  { label: "335910", value: "Battery Manufacturing" },
  { label: "335921", value: "Fiber Optic Cable Manufacturing" },
  { label: "335929", value: "Other Communication and Energy Wire Manufacturing" },
  { label: "335931", value: "Current-Carrying Wiring Device Manufacturing" },
  { label: "335932", value: "Noncurrent-Carrying Wiring Device Manufacturing" },
  { label: "335991", value: "Carbon and Graphite Product Manufacturing" },
  {
    label: "335999",
    value: "All Other Miscellaneous Electrical Equipment and Component Manufacturing",
  },
  { label: "3361", value: "Motor Vehicle Manufacturing" },
  { label: "336110", value: "Automobile and Light Duty Motor Vehicle Manufacturing" },
  { label: "336120", value: "Heavy Duty Truck Manufacturing" },
  { label: "3362", value: "Motor Vehicle Body and Trailer Manufacturing" },
  { label: "336211", value: "Motor Vehicle Body Manufacturing" },
  { label: "336212", value: "Truck Trailer Manufacturing" },
  { label: "336213", value: "Motor Home Manufacturing" },
  { label: "336214", value: "Travel Trailer and Camper Manufacturing" },
  { label: "3363", value: "Motor Vehicle Parts Manufacturing" },
  {
    label: "336310",
    value: "Motor Vehicle Gasoline Engine and Engine Parts Manufacturing",
  },
  {
    label: "336320",
    value: "Motor Vehicle Electrical and Electronic Equipment Manufacturing",
  },
  {
    label: "336330",
    value:
      "Motor Vehicle Steering and Suspension Components (except Spring) Manufacturing",
  },
  { label: "336340", value: "Motor Vehicle Brake System Manufacturing" },
  {
    label: "336350",
    value: "Motor Vehicle Transmission and Power Train Parts Manufacturing",
  },
  { label: "336360", value: "Motor Vehicle Seating and Interior Trim Manufacturing" },
  { label: "336370", value: "Motor Vehicle Metal Stamping" },
  { label: "336390", value: "Other Motor Vehicle Parts Manufacturing" },
  { label: "3364", value: "Aerospace Product and Parts Manufacturing" },
  { label: "336411", value: "Aircraft Manufacturing" },
  { label: "336412", value: "Aircraft Engine and Engine Parts Manufacturing" },
  {
    label: "336413",
    value: "Other Aircraft Parts and Auxiliary Equipment Manufacturing",
  },
  { label: "336414", value: "Guided Missile and Space Vehicle Manufacturing" },
  {
    label: "336415",
    value:
      "Guided Missile and Space Vehicle Propulsion Unit and Propulsion Unit Parts Manufacturing",
  },
  {
    label: "336419",
    value:
      "Other Guided Missile and Space Vehicle Parts and Auxiliary Equipment Manufacturing",
  },
  { label: "3365", value: "Railroad Rolling Stock Manufacturing" },
  { label: "336510", value: "Railroad Rolling Stock Manufacturing" },
  { label: "3366", value: "Ship and Boat Building" },
  { label: "336611", value: "Ship Building and Repairing" },
  { label: "336612", value: "Boat Building" },
  { label: "3369", value: "Other Transportation Equipment Manufacturing" },
  { label: "336991", value: "Motorcycle, Bicycle, and Parts Manufacturing" },
  {
    label: "336992",
    value: "Military Armored Vehicle, Tank, and Tank Component Manufacturing",
  },
  { label: "336999", value: "All Other Transportation Equipment Manufacturing" },
  {
    label: "3371",
    value: "Household and Institutional Furniture and Kitchen Cabinet Manufacturing",
  },
  { label: "337110", value: "Wood Kitchen Cabinet and Countertop Manufacturing" },
  { label: "337121", value: "Upholstered Household Furniture Manufacturing" },
  { label: "337122", value: "Nonupholstered Wood Household Furniture Manufacturing" },
  {
    label: "337126",
    value: "Household Furniture (except Wood and Upholstered) Manufacturing",
  },
  { label: "337127", value: "Institutional Furniture Manufacturing" },
  { label: "3372", value: "Office Furniture (including Fixtures) Manufacturing" },
  { label: "337211", value: "Wood Office Furniture Manufacturing" },
  { label: "337212", value: "Custom Architectural Woodwork and Millwork Manufacturing" },
  { label: "337214", value: "Office Furniture (except Wood) Manufacturing" },
  { label: "337215", value: "Showcase, Partition, Shelving, and Locker Manufacturing" },
  { label: "3379", value: "Other Furniture Related Product Manufacturing" },
  { label: "337910", value: "Mattress Manufacturing" },
  { label: "337920", value: "Blind and Shade Manufacturing" },
  { label: "3391", value: "Medical Equipment and Supplies Manufacturing" },
  { label: "339112", value: "Surgical and Medical Instrument Manufacturing" },
  { label: "339113", value: "Surgical Appliance and Supplies Manufacturing" },
  { label: "339114", value: "Dental Equipment and Supplies Manufacturing" },
  { label: "339115", value: "Ophthalmic Goods Manufacturing" },
  { label: "339116", value: "Dental Laboratories" },
  { label: "3399", value: "Other Miscellaneous Manufacturing" },
  { label: "339910", value: "Jewelry and Silverware Manufacturing" },
  { label: "339920", value: "Sporting and Athletic Goods Manufacturing" },
  { label: "339930", value: "Doll, Toy, and Game Manufacturing" },
  { label: "339940", value: "Office Supplies (except Paper) Manufacturing" },
  { label: "339950", value: "Sign Manufacturing" },
  { label: "339991", value: "Gasket, Packing, and Sealing Device Manufacturing" },
  { label: "339992", value: "Musical Instrument Manufacturing" },
  { label: "339993", value: "Fastener, Button, Needle, and Pin Manufacturing" },
  { label: "339994", value: "Broom, Brush, and Mop Manufacturing" },
  { label: "339995", value: "Burial Casket Manufacturing" },
  { label: "339999", value: "All Other Miscellaneous Manufacturing" },
  { label: "42", value: "Wholesale Trade" },
  { label: "423110", value: "Automobile and Other Motor Vehicle Merchant Wholesalers" },
  { label: "423120", value: "Motor Vehicle Supplies and New Parts Merchant Wholesalers" },
  { label: "423130", value: "Tire and Tube Merchant Wholesalers" },
  { label: "423140", value: "Motor Vehicle Parts (Used) Merchant Wholesalers" },
  { label: "423210", value: "Furniture Merchant Wholesalers" },
  { label: "423220", value: "Home Furnishing Merchant Wholesalers" },
  {
    label: "423310",
    value: "Lumber, Plywood, Millwork, and Wood Panel Merchant Wholesalers",
  },
  {
    label: "423320",
    value: "Brick, Stone, and Related Construction Material Merchant Wholesalers",
  },
  {
    label: "423330",
    value: "Roofing, Siding, and Insulation Material Merchant Wholesalers",
  },
  { label: "423390", value: "Other Construction Material Merchant Wholesalers" },
  { label: "423410", value: "Photographic Equipment and Supplies Merchant Wholesalers" },
  { label: "423420", value: "Office Equipment Merchant Wholesalers" },
  {
    label: "423430",
    value: "Computer and Computer Peripheral Equipment and Software Merchant Wholesalers",
  },
  { label: "423440", value: "Other Commercial Equipment Merchant Wholesalers" },
  {
    label: "423450",
    value: "Medical, Dental, and Hospital Equipment and Supplies Merchant Wholesalers",
  },
  { label: "423460", value: "Ophthalmic Goods Merchant Wholesalers" },
  {
    label: "423490",
    value: "Other Professional Equipment and Supplies Merchant Wholesalers",
  },
  {
    label: "423510",
    value: "Metal Service Centers and Other Metal Merchant Wholesalers",
  },
  { label: "423520", value: "Coal and Other Mineral and Ore Merchant Wholesalers" },
  {
    label: "423610",
    value:
      "Electrical Apparatus and Equipment, Wiring Supplies, and Related Equipment Merchant Wholesalers",
  },
  {
    label: "423620",
    value:
      "Household Appliances, Electric Housewares, and Consumer Electronics Merchant Wholesalers",
  },
  { label: "423690", value: "Other Electronic Parts and Equipment Merchant Wholesalers" },
  { label: "423710", value: "Hardware Merchant Wholesalers" },
  {
    label: "423720",
    value: "Plumbing and Heating Equipment and Supplies (Hydronics) Merchant Wholesalers",
  },
  {
    label: "423730",
    value:
      "Warm Air Heating and Air-Conditioning Equipment and Supplies Merchant Wholesalers",
  },
  { label: "423740", value: "Refrigeration Equipment and Supplies Merchant Wholesalers" },
  {
    label: "423810",
    value:
      "Construction and Mining (except Oil Well) Machinery and Equipment Merchant Wholesalers",
  },
  {
    label: "423820",
    value: "Farm and Garden Machinery and Equipment Merchant Wholesalers",
  },
  { label: "423830", value: "Industrial Machinery and Equipment Merchant Wholesalers" },
  { label: "423840", value: "Industrial Supplies Merchant Wholesalers" },
  {
    label: "423850",
    value: "Service Establishment Equipment and Supplies Merchant Wholesalers",
  },
  {
    label: "423860",
    value:
      "Transportation Equipment and Supplies (except Motor Vehicle) Merchant Wholesalers",
  },
  {
    label: "423910",
    value: "Sporting and Recreational Goods and Supplies Merchant Wholesalers",
  },
  { label: "423920", value: "Toy and Hobby Goods and Supplies Merchant Wholesalers" },
  { label: "423930", value: "Recyclable Material Merchant Wholesalers" },
  {
    label: "423940",
    value: "Jewelry, Watch, Precious Stone, and Precious Metal Merchant Wholesalers",
  },
  { label: "423990", value: "Other Miscellaneous Durable Goods Merchant Wholesalers" },
  { label: "424110", value: "Printing and Writing Paper Merchant Wholesalers" },
  { label: "424120", value: "Stationery and Office Supplies Merchant Wholesalers" },
  {
    label: "424130",
    value: "Industrial and Personal Service Paper Merchant Wholesalers",
  },
  { label: "424210", value: "Drugs and Druggists' Sundries Merchant Wholesalers" },
  {
    label: "424310",
    value: "Piece Goods, Notions, and Other Dry Goods Merchant Wholesalers",
  },
  { label: "424340", value: "Footwear Merchant Wholesalers" },
  { label: "424350", value: "Clothing and Clothing Accessories Merchant Wholesalers" },
  { label: "424410", value: "General Line Grocery Merchant Wholesalers" },
  { label: "424420", value: "Packaged Frozen Food Merchant Wholesalers" },
  {
    label: "424430",
    value: "Dairy Product (except Dried or Canned) Merchant Wholesalers",
  },
  { label: "424440", value: "Poultry and Poultry Product Merchant Wholesalers" },
  { label: "424450", value: "Confectionery Merchant Wholesalers" },
  { label: "424460", value: "Fish and Seafood Merchant Wholesalers" },
  { label: "424470", value: "Meat and Meat Product Merchant Wholesalers" },
  { label: "424480", value: "Fresh Fruit and Vegetable Merchant Wholesalers" },
  { label: "424490", value: "Other Grocery and Related Products Merchant Wholesalers" },
  { label: "424510", value: "Grain and Field Bean Merchant Wholesalers" },
  { label: "424520", value: "Livestock Merchant Wholesalers" },
  { label: "424590", value: "Other Farm Product Raw Material Merchant Wholesalers" },
  {
    label: "424610",
    value: "Plastics Materials and Basic Forms and Shapes Merchant Wholesalers",
  },
  { label: "424690", value: "Other Chemical and Allied Products Merchant Wholesalers" },
  { label: "424710", value: "Petroleum Bulk Stations and Terminals" },
  {
    label: "424720",
    value:
      "Petroleum and Petroleum Products Merchant Wholesalers (except Bulk Stations and Terminals)",
  },
  { label: "424810", value: "Beer and Ale Merchant Wholesalers" },
  {
    label: "424820",
    value: "Wine and Distilled Alcoholic Beverage Merchant Wholesalers",
  },
  { label: "424910", value: "Farm Supplies Merchant Wholesalers" },
  { label: "424920", value: "Book, Periodical, and Newspaper Merchant Wholesalers" },
  {
    label: "424930",
    value: "Flower, Nursery Stock, and Florists' Supplies Merchant Wholesalers",
  },
  {
    label: "424940",
    value: "Tobacco Product and Electronic Cigarette Merchant Wholesalers",
  },
  { label: "424950", value: "Paint, Varnish, and Supplies Merchant Wholesalers" },
  { label: "424990", value: "Other Miscellaneous Nondurable Goods Merchant Wholesalers" },
  { label: "425120", value: "Wholesale Trade Agents and Brokers" },
  {
    label: "4231",
    value: "Motor Vehicle and Motor Vehicle Parts and Supplies Merchant Wholesalers",
  },
  { label: "423110", value: "Automobile and Other Motor Vehicle Merchant Wholesalers" },
  { label: "423120", value: "Motor Vehicle Supplies and New Parts Merchant Wholesalers" },
  { label: "423130", value: "Tire and Tube Merchant Wholesalers" },
  { label: "423140", value: "Motor Vehicle Parts (Used) Merchant Wholesalers" },
  { label: "4232", value: "Furniture and Home Furnishing Merchant Wholesalers" },
  { label: "423210", value: "Furniture Merchant Wholesalers" },
  { label: "423220", value: "Home Furnishing Merchant Wholesalers" },
  {
    label: "4233",
    value: "Lumber and Other Construction Materials Merchant Wholesalers",
  },
  {
    label: "423310",
    value: "Lumber, Plywood, Millwork, and Wood Panel Merchant Wholesalers",
  },
  {
    label: "423320",
    value: "Brick, Stone, and Related Construction Material Merchant Wholesalers",
  },
  {
    label: "423330",
    value: "Roofing, Siding, and Insulation Material Merchant Wholesalers",
  },
  { label: "423390", value: "Other Construction Material Merchant Wholesalers" },
  {
    label: "4234",
    value: "Professional and Commercial Equipment and Supplies Merchant Wholesalers",
  },
  { label: "423410", value: "Photographic Equipment and Supplies Merchant Wholesalers" },
  { label: "423420", value: "Office Equipment Merchant Wholesalers" },
  {
    label: "423430",
    value: "Computer and Computer Peripheral Equipment and Software Merchant Wholesalers",
  },
  { label: "423440", value: "Other Commercial Equipment Merchant Wholesalers" },
  {
    label: "423450",
    value: "Medical, Dental, and Hospital Equipment and Supplies Merchant Wholesalers",
  },
  { label: "423460", value: "Ophthalmic Goods Merchant Wholesalers" },
  {
    label: "423490",
    value: "Other Professional Equipment and Supplies Merchant Wholesalers",
  },
  { label: "4235", value: "Metal and Mineral (except Petroleum) Merchant Wholesalers" },
  {
    label: "423510",
    value: "Metal Service Centers and Other Metal Merchant Wholesalers",
  },
  { label: "423520", value: "Coal and Other Mineral and Ore Merchant Wholesalers" },
  {
    label: "4236",
    value:
      "Household Appliances and Electrical and Electronic Goods Merchant Wholesalers",
  },
  {
    label: "423610",
    value:
      "Electrical Apparatus and Equipment, Wiring Supplies, and Related Equipment Merchant Wholesalers",
  },
  {
    label: "423620",
    value:
      "Household Appliances, Electric Housewares, and Consumer Electronics Merchant Wholesalers",
  },
  { label: "423690", value: "Other Electronic Parts and Equipment Merchant Wholesalers" },
  {
    label: "4237",
    value:
      "Hardware, and Plumbing and Heating Equipment and Supplies Merchant Wholesalers",
  },
  { label: "423710", value: "Hardware Merchant Wholesalers" },
  {
    label: "423720",
    value: "Plumbing and Heating Equipment and Supplies (Hydronics) Merchant Wholesalers",
  },
  {
    label: "423730",
    value:
      "Warm Air Heating and Air-Conditioning Equipment and Supplies Merchant Wholesalers",
  },
  { label: "423740", value: "Refrigeration Equipment and Supplies Merchant Wholesalers" },
  { label: "4238", value: "Machinery, Equipment, and Supplies Merchant Wholesalers" },
  {
    label: "423810",
    value:
      "Construction and Mining (except Oil Well) Machinery and Equipment Merchant Wholesalers",
  },
  {
    label: "423820",
    value: "Farm and Garden Machinery and Equipment Merchant Wholesalers",
  },
  { label: "423830", value: "Industrial Machinery and Equipment Merchant Wholesalers" },
  { label: "423840", value: "Industrial Supplies Merchant Wholesalers" },
  {
    label: "423850",
    value: "Service Establishment Equipment and Supplies Merchant Wholesalers",
  },
  {
    label: "423860",
    value:
      "Transportation Equipment and Supplies (except Motor Vehicle) Merchant Wholesalers",
  },
  { label: "4239", value: "Miscellaneous Durable Goods Merchant Wholesalers" },
  {
    label: "423910",
    value: "Sporting and Recreational Goods and Supplies Merchant Wholesalers",
  },
  { label: "423920", value: "Toy and Hobby Goods and Supplies Merchant Wholesalers" },
  { label: "423930", value: "Recyclable Material Merchant Wholesalers" },
  {
    label: "423940",
    value: "Jewelry, Watch, Precious Stone, and Precious Metal Merchant Wholesalers",
  },
  { label: "423990", value: "Other Miscellaneous Durable Goods Merchant Wholesalers" },
  { label: "4241", value: "Paper and Paper Product Merchant Wholesalers" },
  { label: "424110", value: "Printing and Writing Paper Merchant Wholesalers" },
  { label: "424120", value: "Stationery and Office Supplies Merchant Wholesalers" },
  {
    label: "424130",
    value: "Industrial and Personal Service Paper Merchant Wholesalers",
  },
  { label: "4242", value: "Drugs and Druggists' Sundries Merchant Wholesalers" },
  { label: "424210", value: "Drugs and Druggists' Sundries Merchant Wholesalers" },
  { label: "4243", value: "Apparel, Piece Goods, and Notions Merchant Wholesalers" },
  {
    label: "424310",
    value: "Piece Goods, Notions, and Other Dry Goods Merchant Wholesalers",
  },
  { label: "424340", value: "Footwear Merchant Wholesalers" },
  { label: "424350", value: "Clothing and Clothing Accessories Merchant Wholesalers" },
  { label: "4244", value: "Grocery and Related Product Merchant Wholesalers" },
  { label: "424410", value: "General Line Grocery Merchant Wholesalers" },
  { label: "424420", value: "Packaged Frozen Food Merchant Wholesalers" },
  {
    label: "424430",
    value: "Dairy Product (except Dried or Canned) Merchant Wholesalers",
  },
  { label: "424440", value: "Poultry and Poultry Product Merchant Wholesalers" },
  { label: "424450", value: "Confectionery Merchant Wholesalers" },
  { label: "424460", value: "Fish and Seafood Merchant Wholesalers" },
  { label: "424470", value: "Meat and Meat Product Merchant Wholesalers" },
  { label: "424480", value: "Fresh Fruit and Vegetable Merchant Wholesalers" },
  { label: "424490", value: "Other Grocery and Related Products Merchant Wholesalers" },
  { label: "4245", value: "Farm Product Raw Material Merchant Wholesalers" },
  { label: "424510", value: "Grain and Field Bean Merchant Wholesalers" },
  { label: "424520", value: "Livestock Merchant Wholesalers" },
  { label: "424590", value: "Other Farm Product Raw Material Merchant Wholesalers" },
  { label: "4246", value: "Chemical and Allied Products Merchant Wholesalers" },
  {
    label: "424610",
    value: "Plastics Materials and Basic Forms and Shapes Merchant Wholesalers",
  },
  { label: "424690", value: "Other Chemical and Allied Products Merchant Wholesalers" },
  { label: "4247", value: "Petroleum and Petroleum Products Merchant Wholesalers" },
  { label: "424710", value: "Petroleum Bulk Stations and Terminals" },
  {
    label: "424720",
    value:
      "Petroleum and Petroleum Products Merchant Wholesalers (except Bulk Stations and Terminals)",
  },
  {
    label: "4248",
    value: "Beer, Wine, and Distilled Alcoholic Beverage Merchant Wholesalers",
  },
  { label: "424810", value: "Beer and Ale Merchant Wholesalers" },
  {
    label: "424820",
    value: "Wine and Distilled Alcoholic Beverage Merchant Wholesalers",
  },
  { label: "4249", value: "Miscellaneous Nondurable Goods Merchant Wholesalers" },
  { label: "424910", value: "Farm Supplies Merchant Wholesalers" },
  { label: "424920", value: "Book, Periodical, and Newspaper Merchant Wholesalers" },
  {
    label: "424930",
    value: "Flower, Nursery Stock, and Florists' Supplies Merchant Wholesalers",
  },
  {
    label: "424940",
    value: "Tobacco Product and Electronic Cigarette Merchant Wholesalers",
  },
  { label: "424950", value: "Paint, Varnish, and Supplies Merchant Wholesalers" },
  { label: "424990", value: "Other Miscellaneous Nondurable Goods Merchant Wholesalers" },
  { label: "4251", value: "Wholesale Trade Agents and Brokers" },
  { label: "425120", value: "Wholesale Trade Agents and Brokers" },
  { label: "44", value: "Retail Trade" },
  { label: "441110", value: "New Car Dealers" },
  { label: "441120", value: "Used Car Dealers" },
  { label: "441210", value: "Recreational Vehicle Dealers" },
  { label: "441222", value: "Boat Dealers" },
  { label: "441227", value: "Motorcycle, ATV, and All Other Motor Vehicle Dealers" },
  { label: "441330", value: "Automotive Parts and Accessories Retailers" },
  { label: "441340", value: "Tire Dealers" },
  { label: "444110", value: "Home Centers" },
  { label: "444120", value: "Paint and Wallpaper Retailers" },
  { label: "444140", value: "Hardware Retailers" },
  { label: "444180", value: "Other Building Material Dealers" },
  { label: "444230", value: "Outdoor Power Equipment Retailers" },
  { label: "444240", value: "Nursery, Garden Center, and Farm Supply Retailers" },
  {
    label: "445110",
    value: "Supermarkets and Other Grocery Retailers (except Convenience Retailers)",
  },
  { label: "445131", value: "Convenience Retailers" },
  { label: "445132", value: "Vending Machine Operators" },
  { label: "445230", value: "Fruit and Vegetable Retailers" },
  { label: "445240", value: "Meat Retailers" },
  { label: "445250", value: "Fish and Seafood Retailers" },
  { label: "445291", value: "Baked Goods Retailers" },
  { label: "445292", value: "Confectionery and Nut Retailers" },
  { label: "445298", value: "All Other Specialty Food Retailers" },
  { label: "445320", value: "Beer, Wine, and Liquor Retailers" },
  { label: "449110", value: "Furniture Retailers" },
  { label: "449121", value: "Floor Covering Retailers" },
  { label: "449122", value: "Window Treatment Retailers" },
  { label: "449129", value: "All Other Home Furnishings Retailers" },
  { label: "449210", value: "Electronics and Appliance Retailers" },
  { label: "455110", value: "Department Stores" },
  { label: "455211", value: "Warehouse Clubs and Supercenters" },
  { label: "455219", value: "All Other General Merchandise Retailers" },
  { label: "456110", value: "Pharmacies and Drug Retailers" },
  { label: "456120", value: "Cosmetics, Beauty Supplies, and Perfume Retailers" },
  { label: "456130", value: "Optical Goods Retailers" },
  { label: "456191", value: "Food (Health) Supplement Retailers" },
  { label: "456199", value: "All Other Health and Personal Care Retailers" },
  { label: "457110", value: "Gasoline Stations with Convenience Stores" },
  { label: "457120", value: "Other Gasoline Stations" },
  { label: "457210", value: "Fuel Dealers" },
  { label: "458110", value: "Clothing and Clothing Accessories Retailers" },
  { label: "458210", value: "Shoe Retailers" },
  { label: "458310", value: "Jewelry Retailers" },
  { label: "458320", value: "Luggage and Leather Goods Retailers" },
  { label: "459110", value: "Sporting Goods Retailers" },
  { label: "459120", value: "Hobby, Toy, and Game Retailers" },
  { label: "459130", value: "Sewing, Needlework, and Piece Goods Retailers" },
  { label: "459140", value: "Musical Instrument and Supplies Retailers" },
  { label: "459210", value: "Book Retailers and News Dealers" },
  { label: "459310", value: "Florists" },
  { label: "459410", value: "Office Supplies and Stationery Retailers" },
  { label: "459420", value: "Gift, Novelty, and Souvenir Retailers" },
  { label: "459510", value: "Used Merchandise Retailers" },
  { label: "459910", value: "Pet and Pet Supplies Retailers" },
  { label: "459920", value: "Art Dealers" },
  { label: "459930", value: "Manufactured (Mobile) Home Dealers" },
  {
    label: "459991",
    value: "Tobacco, Electronic Cigarette, and Other Smoking Supplies Retailers",
  },
  { label: "459999", value: "All Other Miscellaneous Retailers" },
  { label: "4411", value: "Automobile Dealers" },
  { label: "441110", value: "New Car Dealers" },
  { label: "441120", value: "Used Car Dealers" },
  { label: "4412", value: "Other Motor Vehicle Dealers" },
  { label: "441210", value: "Recreational Vehicle Dealers" },
  { label: "441222", value: "Boat Dealers" },
  { label: "441227", value: "Motorcycle, ATV, and All Other Motor Vehicle Dealers" },
  { label: "4413", value: "Automotive Parts, Accessories, and Tire Retailers" },
  { label: "441330", value: "Automotive Parts and Accessories Retailers" },
  { label: "441340", value: "Tire Dealers" },
  { label: "4441", value: "Building Material and Supplies Dealers" },
  { label: "444110", value: "Home Centers" },
  { label: "444120", value: "Paint and Wallpaper Retailers" },
  { label: "444140", value: "Hardware Retailers" },
  { label: "444180", value: "Other Building Material Dealers" },
  { label: "4442", value: "Lawn and Garden Equipment and Supplies Retailers" },
  { label: "444230", value: "Outdoor Power Equipment Retailers" },
  { label: "444240", value: "Nursery, Garden Center, and Farm Supply Retailers" },
  { label: "4451", value: "Grocery and Convenience Retailers" },
  {
    label: "445110",
    value: "Supermarkets and Other Grocery Retailers (except Convenience Retailers)",
  },
  { label: "445131", value: "Convenience Retailers" },
  { label: "445132", value: "Vending Machine Operators" },
  { label: "4452", value: "Specialty Food Retailers" },
  { label: "445230", value: "Fruit and Vegetable Retailers" },
  { label: "445240", value: "Meat Retailers" },
  { label: "445250", value: "Fish and Seafood Retailers" },
  { label: "445291", value: "Baked Goods Retailers" },
  { label: "445292", value: "Confectionery and Nut Retailers" },
  { label: "445298", value: "All Other Specialty Food Retailers" },
  { label: "4453", value: "Beer, Wine, and Liquor Retailers" },
  { label: "445320", value: "Beer, Wine, and Liquor Retailers" },
  { label: "4491", value: "Furniture and Home Furnishings Retailers" },
  { label: "449110", value: "Furniture Retailers" },
  { label: "449121", value: "Floor Covering Retailers" },
  { label: "449122", value: "Window Treatment Retailers" },
  { label: "449129", value: "All Other Home Furnishings Retailers" },
  { label: "4492", value: "Electronics and Appliance Retailers" },
  { label: "449210", value: "Electronics and Appliance Retailers" },
  { label: "4551", value: "Department Stores" },
  { label: "455110", value: "Department Stores" },
  {
    label: "4552",
    value: "Warehouse Clubs, Supercenters, and Other General Merchandise Retailers",
  },
  { label: "455211", value: "Warehouse Clubs and Supercenters" },
  { label: "455219", value: "All Other General Merchandise Retailers" },
  { label: "4561", value: "Health and Personal Care Retailers" },
  { label: "456110", value: "Pharmacies and Drug Retailers" },
  { label: "456120", value: "Cosmetics, Beauty Supplies, and Perfume Retailers" },
  { label: "456130", value: "Optical Goods Retailers" },
  { label: "456191", value: "Food (Health) Supplement Retailers" },
  { label: "456199", value: "All Other Health and Personal Care Retailers" },
  { label: "4571", value: "Gasoline Stations" },
  { label: "457110", value: "Gasoline Stations with Convenience Stores" },
  { label: "457120", value: "Other Gasoline Stations" },
  { label: "4572", value: "Fuel Dealers" },
  { label: "457210", value: "Fuel Dealers" },
  { label: "4581", value: "Clothing and Clothing Accessories Retailers" },
  { label: "458110", value: "Clothing and Clothing Accessories Retailers" },
  { label: "4582", value: "Shoe Retailers" },
  { label: "458210", value: "Shoe Retailers" },
  { label: "4583", value: "Jewelry, Luggage, and Leather Goods Retailers" },
  { label: "458310", value: "Jewelry Retailers" },
  { label: "458320", value: "Luggage and Leather Goods Retailers" },
  { label: "4591", value: "Sporting Goods, Hobby, and Musical Instrument Retailers" },
  { label: "459110", value: "Sporting Goods Retailers" },
  { label: "459120", value: "Hobby, Toy, and Game Retailers" },
  { label: "459130", value: "Sewing, Needlework, and Piece Goods Retailers" },
  { label: "459140", value: "Musical Instrument and Supplies Retailers" },
  { label: "4592", value: "Book Retailers and News Dealers" },
  { label: "459210", value: "Book Retailers and News Dealers" },
  { label: "4593", value: "Florists" },
  { label: "459310", value: "Florists" },
  { label: "4594", value: "Office Supplies, Stationery, and Gift Retailers" },
  { label: "459410", value: "Office Supplies and Stationery Retailers" },
  { label: "459420", value: "Gift, Novelty, and Souvenir Retailers" },
  { label: "4595", value: "Used Merchandise Retailers" },
  { label: "459510", value: "Used Merchandise Retailers" },
  { label: "4599", value: "Other Miscellaneous Retailers" },
  { label: "459910", value: "Pet and Pet Supplies Retailers" },
  { label: "459920", value: "Art Dealers" },
  { label: "459930", value: "Manufactured (Mobile) Home Dealers" },
  {
    label: "459991",
    value: "Tobacco, Electronic Cigarette, and Other Smoking Supplies Retailers",
  },
  { label: "459999", value: "All Other Miscellaneous Retailers" },
  { label: "48", value: "Transportation and Warehousing" },
  { label: "481111", value: "Scheduled Passenger Air Transportation" },
  { label: "481112", value: "Scheduled Freight Air Transportation" },
  { label: "481211", value: "Nonscheduled Chartered Passenger Air Transportation" },
  { label: "481212", value: "Nonscheduled Chartered Freight Air Transportation" },
  { label: "481219", value: "Other Nonscheduled Air Transportation" },
  { label: "482111", value: "Line-Haul Railroads" },
  { label: "482112", value: "Short Line Railroads" },
  { label: "483111", value: "Deep Sea Freight Transportation" },
  { label: "483112", value: "Deep Sea Passenger Transportation" },
  { label: "483113", value: "Coastal and Great Lakes Freight Transportation" },
  { label: "483114", value: "Coastal and Great Lakes Passenger Transportation" },
  { label: "483211", value: "Inland Water Freight Transportation" },
  { label: "483212", value: "Inland Water Passenger Transportation" },
  { label: "484110", value: "General Freight Trucking, Local" },
  { label: "484121", value: "General Freight Trucking, Long-Distance, Truckload" },
  {
    label: "484122",
    value: "General Freight Trucking, Long-Distance, Less Than Truckload",
  },
  { label: "484210", value: "Used Household and Office Goods Moving" },
  { label: "484220", value: "Specialized Freight (except Used Goods) Trucking, Local" },
  {
    label: "484230",
    value: "Specialized Freight (except Used Goods) Trucking, Long-Distance",
  },
  { label: "485111", value: "Mixed Mode Transit Systems" },
  { label: "485112", value: "Commuter Rail Systems" },
  { label: "485113", value: "Bus and Other Motor Vehicle Transit Systems" },
  { label: "485119", value: "Other Urban Transit Systems" },
  { label: "485210", value: "Interurban and Rural Bus Transportation" },
  { label: "485310", value: "Taxi and Ridesharing Services" },
  { label: "485320", value: "Limousine Service" },
  { label: "485410", value: "School and Employee Bus Transportation" },
  { label: "485510", value: "Charter Bus Industry" },
  { label: "485991", value: "Special Needs Transportation" },
  { label: "485999", value: "All Other Transit and Ground Passenger Transportation" },
  { label: "486110", value: "Pipeline Transportation of Crude Oil" },
  { label: "486210", value: "Pipeline Transportation of Natural Gas" },
  { label: "486910", value: "Pipeline Transportation of Refined Petroleum Products" },
  { label: "486990", value: "All Other Pipeline Transportation" },
  { label: "487110", value: "Scenic and Sightseeing Transportation, Land" },
  { label: "487210", value: "Scenic and Sightseeing Transportation, Water" },
  { label: "487990", value: "Scenic and Sightseeing Transportation, Other" },
  { label: "488111", value: "Air Traffic Control" },
  { label: "488119", value: "Other Airport Operations" },
  { label: "488190", value: "Other Support Activities for Air Transportation" },
  { label: "488210", value: "Support Activities for Rail Transportation" },
  { label: "488310", value: "Port and Harbor Operations" },
  { label: "488320", value: "Marine Cargo Handling" },
  { label: "488330", value: "Navigational Services to Shipping" },
  { label: "488390", value: "Other Support Activities for Water Transportation" },
  { label: "488410", value: "Motor Vehicle Towing" },
  { label: "488490", value: "Other Support Activities for Road Transportation" },
  { label: "488510", value: "Freight Transportation Arrangement" },
  { label: "488991", value: "Packing and Crating" },
  { label: "488999", value: "All Other Support Activities for Transportation" },
  { label: "491110", value: "Postal Service" },
  { label: "492110", value: "Couriers and Express Delivery Services" },
  { label: "492210", value: "Local Messengers and Local Delivery" },
  { label: "493110", value: "General Warehousing and Storage" },
  { label: "493120", value: "Refrigerated Warehousing and Storage" },
  { label: "493130", value: "Farm Product Warehousing and Storage" },
  { label: "493190", value: "Other Warehousing and Storage" },
  { label: "4811", value: "Scheduled Air Transportation" },
  { label: "481111", value: "Scheduled Passenger Air Transportation" },
  { label: "481112", value: "Scheduled Freight Air Transportation" },
  { label: "4812", value: "Nonscheduled Air Transportation" },
  { label: "481211", value: "Nonscheduled Chartered Passenger Air Transportation" },
  { label: "481212", value: "Nonscheduled Chartered Freight Air Transportation" },
  { label: "481219", value: "Other Nonscheduled Air Transportation" },
  { label: "4821", value: "Rail Transportation" },
  { label: "482111", value: "Line-Haul Railroads" },
  { label: "482112", value: "Short Line Railroads" },
  { label: "4831", value: "Deep Sea, Coastal, and Great Lakes Water Transportation" },
  { label: "483111", value: "Deep Sea Freight Transportation" },
  { label: "483112", value: "Deep Sea Passenger Transportation" },
  { label: "483113", value: "Coastal and Great Lakes Freight Transportation" },
  { label: "483114", value: "Coastal and Great Lakes Passenger Transportation" },
  { label: "4832", value: "Inland Water Transportation" },
  { label: "483211", value: "Inland Water Freight Transportation" },
  { label: "483212", value: "Inland Water Passenger Transportation" },
  { label: "4841", value: "General Freight Trucking" },
  { label: "484110", value: "General Freight Trucking, Local" },
  { label: "484121", value: "General Freight Trucking, Long-Distance, Truckload" },
  {
    label: "484122",
    value: "General Freight Trucking, Long-Distance, Less Than Truckload",
  },
  { label: "4842", value: "Specialized Freight Trucking" },
  { label: "484210", value: "Used Household and Office Goods Moving" },
  { label: "484220", value: "Specialized Freight (except Used Goods) Trucking, Local" },
  {
    label: "484230",
    value: "Specialized Freight (except Used Goods) Trucking, Long-Distance",
  },
  { label: "4851", value: "Urban Transit Systems" },
  { label: "485111", value: "Mixed Mode Transit Systems" },
  { label: "485112", value: "Commuter Rail Systems" },
  { label: "485113", value: "Bus and Other Motor Vehicle Transit Systems" },
  { label: "485119", value: "Other Urban Transit Systems" },
  { label: "4852", value: "Interurban and Rural Bus Transportation" },
  { label: "485210", value: "Interurban and Rural Bus Transportation" },
  { label: "4853", value: "Taxi and Limousine Service" },
  { label: "485310", value: "Taxi and Ridesharing Services" },
  { label: "485320", value: "Limousine Service" },
  { label: "4854", value: "School and Employee Bus Transportation" },
  { label: "485410", value: "School and Employee Bus Transportation" },
  { label: "4855", value: "Charter Bus Industry" },
  { label: "485510", value: "Charter Bus Industry" },
  { label: "4859", value: "Other Transit and Ground Passenger Transportation" },
  { label: "485991", value: "Special Needs Transportation" },
  { label: "485999", value: "All Other Transit and Ground Passenger Transportation" },
  { label: "4861", value: "Pipeline Transportation of Crude Oil" },
  { label: "486110", value: "Pipeline Transportation of Crude Oil" },
  { label: "4862", value: "Pipeline Transportation of Natural Gas" },
  { label: "486210", value: "Pipeline Transportation of Natural Gas" },
  { label: "4869", value: "Other Pipeline Transportation" },
  { label: "486910", value: "Pipeline Transportation of Refined Petroleum Products" },
  { label: "486990", value: "All Other Pipeline Transportation" },
  { label: "4871", value: "Scenic and Sightseeing Transportation, Land" },
  { label: "487110", value: "Scenic and Sightseeing Transportation, Land" },
  { label: "4872", value: "Scenic and Sightseeing Transportation, Water" },
  { label: "487210", value: "Scenic and Sightseeing Transportation, Water" },
  { label: "4879", value: "Scenic and Sightseeing Transportation, Other" },
  { label: "487990", value: "Scenic and Sightseeing Transportation, Other" },
  { label: "4881", value: "Support Activities for Air Transportation" },
  { label: "488111", value: "Air Traffic Control" },
  { label: "488119", value: "Other Airport Operations" },
  { label: "488190", value: "Other Support Activities for Air Transportation" },
  { label: "4882", value: "Support Activities for Rail Transportation" },
  { label: "488210", value: "Support Activities for Rail Transportation" },
  { label: "4883", value: "Support Activities for Water Transportation" },
  { label: "488310", value: "Port and Harbor Operations" },
  { label: "488320", value: "Marine Cargo Handling" },
  { label: "488330", value: "Navigational Services to Shipping" },
  { label: "488390", value: "Other Support Activities for Water Transportation" },
  { label: "4884", value: "Support Activities for Road Transportation" },
  { label: "488410", value: "Motor Vehicle Towing" },
  { label: "488490", value: "Other Support Activities for Road Transportation" },
  { label: "4885", value: "Freight Transportation Arrangement" },
  { label: "488510", value: "Freight Transportation Arrangement" },
  { label: "4889", value: "Other Support Activities for Transportation" },
  { label: "488991", value: "Packing and Crating" },
  { label: "488999", value: "All Other Support Activities for Transportation" },
  { label: "4911", value: "Postal Service" },
  { label: "491110", value: "Postal Service" },
  { label: "4921", value: "Couriers and Express Delivery Services" },
  { label: "492110", value: "Couriers and Express Delivery Services" },
  { label: "4922", value: "Local Messengers and Local Delivery" },
  { label: "492210", value: "Local Messengers and Local Delivery" },
  { label: "4931", value: "Warehousing and Storage" },
  { label: "493110", value: "General Warehousing and Storage" },
  { label: "493120", value: "Refrigerated Warehousing and Storage" },
  { label: "493130", value: "Farm Product Warehousing and Storage" },
  { label: "493190", value: "Other Warehousing and Storage" },
  { label: "51", value: "Information" },
  { label: "512110", value: "Motion Picture and Video Production" },
  { label: "512120", value: "Motion Picture and Video Distribution" },
  { label: "512131", value: "Motion Picture Theaters (except Drive-Ins)" },
  { label: "512132", value: "Drive-In Motion Picture Theaters" },
  { label: "512191", value: "Teleproduction and Other Postproduction Services" },
  { label: "512199", value: "Other Motion Picture and Video Industries" },
  { label: "512230", value: "Music Publishers" },
  { label: "512240", value: "Sound Recording Studios" },
  { label: "512250", value: "Record Production and Distribution" },
  { label: "512290", value: "Other Sound Recording Industries" },
  { label: "513110", value: "Newspaper Publishers" },
  { label: "513120", value: "Periodical Publishers" },
  { label: "513130", value: "Book Publishers" },
  { label: "513140", value: "Directory and Mailing List Publishers" },
  { label: "513191", value: "Greeting Card Publishers" },
  { label: "513199", value: "All Other Publishers" },
  { label: "513210", value: "Software Publishers" },
  { label: "516110", value: "Radio Broadcasting Stations" },
  { label: "516120", value: "Television Broadcasting Stations" },
  {
    label: "516210",
    value:
      "Media Streaming Distribution Services, Social Networks, and Other Media Networks and Content Providers",
  },
  { label: "517111", value: "Wired Telecommunications Carriers" },
  { label: "517112", value: "Wireless Telecommunications Carriers (except Satellite)" },
  { label: "517121", value: "Telecommunications Resellers" },
  { label: "517122", value: "Agents for Wireless Telecommunications Services" },
  { label: "517410", value: "Satellite Telecommunications" },
  { label: "517810", value: "All Other Telecommunications" },
  {
    label: "518210",
    value:
      "Computing Infrastructure Providers, Data Processing, Web Hosting, and Related Services",
  },
  { label: "519210", value: "Libraries and Archives" },
  { label: "519290", value: "Web Search Portals and All Other Information Services" },
  { label: "5121", value: "Motion Picture and Video Industries" },
  { label: "512110", value: "Motion Picture and Video Production" },
  { label: "512120", value: "Motion Picture and Video Distribution" },
  { label: "512131", value: "Motion Picture Theaters (except Drive-Ins)" },
  { label: "512132", value: "Drive-In Motion Picture Theaters" },
  { label: "512191", value: "Teleproduction and Other Postproduction Services" },
  { label: "512199", value: "Other Motion Picture and Video Industries" },
  { label: "5122", value: "Sound Recording Industries" },
  { label: "512230", value: "Music Publishers" },
  { label: "512240", value: "Sound Recording Studios" },
  { label: "512250", value: "Record Production and Distribution" },
  { label: "512290", value: "Other Sound Recording Industries" },
  { label: "5131", value: "Newspaper, Periodical, Book, and Directory Publishers" },
  { label: "513110", value: "Newspaper Publishers" },
  { label: "513120", value: "Periodical Publishers" },
  { label: "513130", value: "Book Publishers" },
  { label: "513140", value: "Directory and Mailing List Publishers" },
  { label: "513191", value: "Greeting Card Publishers" },
  { label: "513199", value: "All Other Publishers" },
  { label: "5132", value: "Software Publishers" },
  { label: "513210", value: "Software Publishers" },
  { label: "5161", value: "Radio and Television Broadcasting Stations" },
  { label: "516110", value: "Radio Broadcasting Stations" },
  { label: "516120", value: "Television Broadcasting Stations" },
  {
    label: "5162",
    value:
      "Media Streaming Distribution Services, Social Networks, and Other Media Networks and Content Providers",
  },
  {
    label: "516210",
    value:
      "Media Streaming Distribution Services, Social Networks, and Other Media Networks and Content Providers",
  },
  { label: "5171", value: "Wired and Wireless Telecommunications (except Satellite)" },
  { label: "517111", value: "Wired Telecommunications Carriers" },
  { label: "517112", value: "Wireless Telecommunications Carriers (except Satellite)" },
  { label: "517121", value: "Telecommunications Resellers" },
  { label: "517122", value: "Agents for Wireless Telecommunications Services" },
  { label: "5174", value: "Satellite Telecommunications" },
  { label: "517410", value: "Satellite Telecommunications" },
  { label: "5178", value: "All Other Telecommunications" },
  { label: "517810", value: "All Other Telecommunications" },
  {
    label: "5182",
    value:
      "Computing Infrastructure Providers, Data Processing, Web Hosting, and Related Services",
  },
  {
    label: "518210",
    value:
      "Computing Infrastructure Providers, Data Processing, Web Hosting, and Related Services",
  },
  {
    label: "5192",
    value: "Web Search Portals, Libraries, Archives, and Other Information Services",
  },
  { label: "519210", value: "Libraries and Archives" },
  { label: "519290", value: "Web Search Portals and All Other Information Services" },
  { label: "52", value: "Finance and Insurance" },
  { label: "521110", value: "Monetary Authorities-Central Bank" },
  { label: "522110", value: "Commercial Banking" },
  { label: "522130", value: "Credit Unions" },
  {
    label: "522180",
    value: "Savings Institutions and Other Depository Credit Intermediation",
  },
  { label: "522210", value: "Credit Card Issuing" },
  { label: "522220", value: "Sales Financing" },
  { label: "522291", value: "Consumer Lending" },
  { label: "522292", value: "Real Estate Credit" },
  {
    label: "522299",
    value:
      "International, Secondary Market, and All Other Nondepository Credit Intermediation",
  },
  { label: "522310", value: "Mortgage and Nonmortgage Loan Brokers" },
  {
    label: "522320",
    value: "Financial Transactions Processing, Reserve, and Clearinghouse Activities",
  },
  { label: "522390", value: "Other Activities Related to Credit Intermediation" },
  { label: "523150", value: "Investment Banking and Securities Intermediation" },
  { label: "523160", value: "Commodity Contracts Intermediation" },
  { label: "523210", value: "Securities and Commodity Exchanges" },
  { label: "523910", value: "Miscellaneous Intermediation" },
  { label: "523940", value: "Portfolio Management and Investment Advice" },
  { label: "523991", value: "Trust, Fiduciary, and Custody Activities" },
  { label: "523999", value: "Miscellaneous Financial Investment Activities" },
  { label: "524113", value: "Direct Life Insurance Carriers" },
  { label: "524114", value: "Direct Health and Medical Insurance Carriers" },
  { label: "524126", value: "Direct Property and Casualty Insurance Carriers" },
  { label: "524127", value: "Direct Title Insurance Carriers" },
  {
    label: "524128",
    value: "Other Direct Insurance (except Life, Health, and Medical) Carriers",
  },
  { label: "524130", value: "Reinsurance Carriers" },
  { label: "524210", value: "Insurance Agencies and Brokerages" },
  { label: "524291", value: "Claims Adjusting" },
  {
    label: "524292",
    value:
      "Pharmacy Benefit Management and Other Third Party Administration of Insurance and Pension Funds",
  },
  { label: "524298", value: "All Other Insurance Related Activities" },
  { label: "525110", value: "Pension Funds" },
  { label: "525120", value: "Health and Welfare Funds" },
  { label: "525190", value: "Other Insurance Funds" },
  { label: "525910", value: "Open-End Investment Funds" },
  { label: "525920", value: "Trusts, Estates, and Agency Accounts" },
  { label: "525990", value: "Other Financial Vehicles" },
  { label: "5211", value: "Monetary Authorities-Central Bank" },
  { label: "521110", value: "Monetary Authorities-Central Bank" },
  { label: "5221", value: "Depository Credit Intermediation" },
  { label: "522110", value: "Commercial Banking" },
  { label: "522130", value: "Credit Unions" },
  {
    label: "522180",
    value: "Savings Institutions and Other Depository Credit Intermediation",
  },
  { label: "5222", value: "Nondepository Credit Intermediation" },
  { label: "522210", value: "Credit Card Issuing" },
  { label: "522220", value: "Sales Financing" },
  { label: "522291", value: "Consumer Lending" },
  { label: "522292", value: "Real Estate Credit" },
  {
    label: "522299",
    value:
      "International, Secondary Market, and All Other Nondepository Credit Intermediation",
  },
  { label: "5223", value: "Activities Related to Credit Intermediation" },
  { label: "522310", value: "Mortgage and Nonmortgage Loan Brokers" },
  {
    label: "522320",
    value: "Financial Transactions Processing, Reserve, and Clearinghouse Activities",
  },
  { label: "522390", value: "Other Activities Related to Credit Intermediation" },
  {
    label: "5231",
    value: "Securities and Commodity Contracts Intermediation and Brokerage",
  },
  { label: "523150", value: "Investment Banking and Securities Intermediation" },
  { label: "523160", value: "Commodity Contracts Intermediation" },
  { label: "5232", value: "Securities and Commodity Exchanges" },
  { label: "523210", value: "Securities and Commodity Exchanges" },
  { label: "5239", value: "Other Financial Investment Activities" },
  { label: "523910", value: "Miscellaneous Intermediation" },
  { label: "523940", value: "Portfolio Management and Investment Advice" },
  { label: "523991", value: "Trust, Fiduciary, and Custody Activities" },
  { label: "523999", value: "Miscellaneous Financial Investment Activities" },
  { label: "5241", value: "Insurance Carriers" },
  { label: "524113", value: "Direct Life Insurance Carriers" },
  { label: "524114", value: "Direct Health and Medical Insurance Carriers" },
  { label: "524126", value: "Direct Property and Casualty Insurance Carriers" },
  { label: "524127", value: "Direct Title Insurance Carriers" },
  {
    label: "524128",
    value: "Other Direct Insurance (except Life, Health, and Medical) Carriers",
  },
  { label: "524130", value: "Reinsurance Carriers" },
  {
    label: "5242",
    value: "Agencies, Brokerages, and Other Insurance Related Activities",
  },
  { label: "524210", value: "Insurance Agencies and Brokerages" },
  { label: "524291", value: "Claims Adjusting" },
  {
    label: "524292",
    value:
      "Pharmacy Benefit Management and Other Third Party Administration of Insurance and Pension Funds",
  },
  { label: "524298", value: "All Other Insurance Related Activities" },
  { label: "5251", value: "Insurance and Employee Benefit Funds" },
  { label: "525110", value: "Pension Funds" },
  { label: "525120", value: "Health and Welfare Funds" },
  { label: "525190", value: "Other Insurance Funds" },
  { label: "5259", value: "Other Investment Pools and Funds" },
  { label: "525910", value: "Open-End Investment Funds" },
  { label: "525920", value: "Trusts, Estates, and Agency Accounts" },
  { label: "525990", value: "Other Financial Vehicles" },
  { label: "53", value: "Real Estate and Rental and Leasing" },
  { label: "531110", value: "Lessors of Residential Buildings and Dwellings" },
  {
    label: "531120",
    value: "Lessors of Nonresidential Buildings (except Miniwarehouses)",
  },
  { label: "531130", value: "Lessors of Miniwarehouses and Self-Storage Units" },
  { label: "531190", value: "Lessors of Other Real Estate Property" },
  { label: "531210", value: "Offices of Real Estate Agents and Brokers" },
  { label: "531311", value: "Residential Property Managers" },
  { label: "531312", value: "Nonresidential Property Managers" },
  { label: "531320", value: "Offices of Real Estate Appraisers" },
  { label: "531390", value: "Other Activities Related to Real Estate" },
  { label: "532111", value: "Passenger Car Rental" },
  { label: "532112", value: "Passenger Car Leasing" },
  {
    label: "532120",
    value: "Truck, Utility Trailer, and RV (Recreational Vehicle) Rental and Leasing",
  },
  { label: "532210", value: "Consumer Electronics and Appliances Rental" },
  { label: "532281", value: "Formal Wear and Costume Rental" },
  { label: "532282", value: "Video Tape and Disc Rental" },
  { label: "532283", value: "Home Health Equipment Rental" },
  { label: "532284", value: "Recreational Goods Rental" },
  { label: "532289", value: "All Other Consumer Goods Rental" },
  { label: "532310", value: "General Rental Centers" },
  {
    label: "532411",
    value: "Commercial Air, Rail, and Water Transportation Equipment Rental and Leasing",
  },
  {
    label: "532412",
    value:
      "Construction, Mining, and Forestry Machinery and Equipment Rental and Leasing",
  },
  { label: "532420", value: "Office Machinery and Equipment Rental and Leasing" },
  {
    label: "532490",
    value: "Other Commercial and Industrial Machinery and Equipment Rental and Leasing",
  },
  {
    label: "533110",
    value: "Lessors of Nonfinancial Intangible Assets (except Copyrighted Works)",
  },
  { label: "5311", value: "Lessors of Real Estate" },
  { label: "531110", value: "Lessors of Residential Buildings and Dwellings" },
  {
    label: "531120",
    value: "Lessors of Nonresidential Buildings (except Miniwarehouses)",
  },
  { label: "531130", value: "Lessors of Miniwarehouses and Self-Storage Units" },
  { label: "531190", value: "Lessors of Other Real Estate Property" },
  { label: "5312", value: "Offices of Real Estate Agents and Brokers" },
  { label: "531210", value: "Offices of Real Estate Agents and Brokers" },
  { label: "5313", value: "Activities Related to Real Estate" },
  { label: "531311", value: "Residential Property Managers" },
  { label: "531312", value: "Nonresidential Property Managers" },
  { label: "531320", value: "Offices of Real Estate Appraisers" },
  { label: "531390", value: "Other Activities Related to Real Estate" },
  { label: "5321", value: "Automotive Equipment Rental and Leasing" },
  { label: "532111", value: "Passenger Car Rental" },
  { label: "532112", value: "Passenger Car Leasing" },
  {
    label: "532120",
    value: "Truck, Utility Trailer, and RV (Recreational Vehicle) Rental and Leasing",
  },
  { label: "5322", value: "Consumer Goods Rental" },
  { label: "532210", value: "Consumer Electronics and Appliances Rental" },
  { label: "532281", value: "Formal Wear and Costume Rental" },
  { label: "532282", value: "Video Tape and Disc Rental" },
  { label: "532283", value: "Home Health Equipment Rental" },
  { label: "532284", value: "Recreational Goods Rental" },
  { label: "532289", value: "All Other Consumer Goods Rental" },
  { label: "5323", value: "General Rental Centers" },
  { label: "532310", value: "General Rental Centers" },
  {
    label: "5324",
    value: "Commercial and Industrial Machinery and Equipment Rental and Leasing",
  },
  {
    label: "532411",
    value: "Commercial Air, Rail, and Water Transportation Equipment Rental and Leasing",
  },
  {
    label: "532412",
    value:
      "Construction, Mining, and Forestry Machinery and Equipment Rental and Leasing",
  },
  { label: "532420", value: "Office Machinery and Equipment Rental and Leasing" },
  {
    label: "532490",
    value: "Other Commercial and Industrial Machinery and Equipment Rental and Leasing",
  },
  {
    label: "5331",
    value: "Lessors of Nonfinancial Intangible Assets (except Copyrighted Works)",
  },
  {
    label: "533110",
    value: "Lessors of Nonfinancial Intangible Assets (except Copyrighted Works)",
  },
  { label: "54", value: "Professional, Scientific, and Technical Services" },
  { label: "541110", value: "Offices of Lawyers" },
  { label: "541120", value: "Offices of Notaries" },
  { label: "541191", value: "Title Abstract and Settlement Offices" },
  { label: "541199", value: "All Other Legal Services" },
  { label: "541211", value: "Offices of Certified Public Accountants" },
  { label: "541213", value: "Tax Preparation Services" },
  { label: "541214", value: "Payroll Services" },
  { label: "541219", value: "Other Accounting Services" },
  { label: "541310", value: "Architectural Services" },
  { label: "541320", value: "Landscape Architectural Services" },
  { label: "541330", value: "Engineering Services" },
  { label: "541340", value: "Drafting Services" },
  { label: "541350", value: "Building Inspection Services" },
  { label: "541360", value: "Geophysical Surveying and Mapping Services" },
  { label: "541370", value: "Surveying and Mapping (except Geophysical) Services" },
  { label: "541380", value: "Testing Laboratories and Services" },
  { label: "541410", value: "Interior Design Services" },
  { label: "541420", value: "Industrial Design Services" },
  { label: "541430", value: "Graphic Design Services" },
  { label: "541490", value: "Other Specialized Design Services" },
  { label: "541511", value: "Custom Computer Programming Services" },
  { label: "541512", value: "Computer Systems Design Services" },
  { label: "541513", value: "Computer Facilities Management Services" },
  { label: "541519", value: "Other Computer Related Services" },
  {
    label: "541611",
    value: "Administrative Management and General Management Consulting Services",
  },
  { label: "541612", value: "Human Resources Consulting Services" },
  { label: "541613", value: "Marketing Consulting Services" },
  {
    label: "541614",
    value: "Process, Physical Distribution, and Logistics Consulting Services",
  },
  { label: "541618", value: "Other Management Consulting Services" },
  { label: "541620", value: "Environmental Consulting Services" },
  { label: "541690", value: "Other Scientific and Technical Consulting Services" },
  { label: "541713", value: "Research and Development in Nanotechnology" },
  {
    label: "541714",
    value: "Research and Development in Biotechnology (except Nanobiotechnology)",
  },
  {
    label: "541715",
    value:
      "Research and Development in the Physical, Engineering, and Life Sciences (except Nanotechnology and Biotechnology)",
  },
  {
    label: "541720",
    value: "Research and Development in the Social Sciences and Humanities",
  },
  { label: "541810", value: "Advertising Agencies" },
  { label: "541820", value: "Public Relations Agencies" },
  { label: "541830", value: "Media Buying Agencies" },
  { label: "541840", value: "Media Representatives" },
  { label: "541850", value: "Indoor and Outdoor Display Advertising" },
  { label: "541860", value: "Direct Mail Advertising" },
  { label: "541870", value: "Advertising Material Distribution Services" },
  { label: "541890", value: "Other Services Related to Advertising" },
  { label: "541910", value: "Marketing Research and Public Opinion Polling" },
  { label: "541921", value: "Photography Studios, Portrait" },
  { label: "541922", value: "Commercial Photography" },
  { label: "541930", value: "Translation and Interpretation Services" },
  { label: "541940", value: "Veterinary Services" },
  {
    label: "541990",
    value: "All Other Professional, Scientific, and Technical Services",
  },
  { label: "5411", value: "Legal Services" },
  { label: "541110", value: "Offices of Lawyers" },
  { label: "541120", value: "Offices of Notaries" },
  { label: "541191", value: "Title Abstract and Settlement Offices" },
  { label: "541199", value: "All Other Legal Services" },
  {
    label: "5412",
    value: "Accounting, Tax Preparation, Bookkeeping, and Payroll Services",
  },
  { label: "541211", value: "Offices of Certified Public Accountants" },
  { label: "541213", value: "Tax Preparation Services" },
  { label: "541214", value: "Payroll Services" },
  { label: "541219", value: "Other Accounting Services" },
  { label: "5413", value: "Architectural, Engineering, and Related Services" },
  { label: "541310", value: "Architectural Services" },
  { label: "541320", value: "Landscape Architectural Services" },
  { label: "541330", value: "Engineering Services" },
  { label: "541340", value: "Drafting Services" },
  { label: "541350", value: "Building Inspection Services" },
  { label: "541360", value: "Geophysical Surveying and Mapping Services" },
  { label: "541370", value: "Surveying and Mapping (except Geophysical) Services" },
  { label: "541380", value: "Testing Laboratories and Services" },
  { label: "5414", value: "Specialized Design Services" },
  { label: "541410", value: "Interior Design Services" },
  { label: "541420", value: "Industrial Design Services" },
  { label: "541430", value: "Graphic Design Services" },
  { label: "541490", value: "Other Specialized Design Services" },
  { label: "5415", value: "Computer Systems Design and Related Services" },
  { label: "541511", value: "Custom Computer Programming Services" },
  { label: "541512", value: "Computer Systems Design Services" },
  { label: "541513", value: "Computer Facilities Management Services" },
  { label: "541519", value: "Other Computer Related Services" },
  { label: "5416", value: "Management, Scientific, and Technical Consulting Services" },
  {
    label: "541611",
    value: "Administrative Management and General Management Consulting Services",
  },
  { label: "541612", value: "Human Resources Consulting Services" },
  { label: "541613", value: "Marketing Consulting Services" },
  {
    label: "541614",
    value: "Process, Physical Distribution, and Logistics Consulting Services",
  },
  { label: "541618", value: "Other Management Consulting Services" },
  { label: "541620", value: "Environmental Consulting Services" },
  { label: "541690", value: "Other Scientific and Technical Consulting Services" },
  { label: "5417", value: "Scientific Research and Development Services" },
  { label: "541713", value: "Research and Development in Nanotechnology" },
  {
    label: "541714",
    value: "Research and Development in Biotechnology (except Nanobiotechnology)",
  },
  {
    label: "541715",
    value:
      "Research and Development in the Physical, Engineering, and Life Sciences (except Nanotechnology and Biotechnology)",
  },
  {
    label: "541720",
    value: "Research and Development in the Social Sciences and Humanities",
  },
  { label: "5418", value: "Advertising, Public Relations, and Related Services" },
  { label: "541810", value: "Advertising Agencies" },
  { label: "541820", value: "Public Relations Agencies" },
  { label: "541830", value: "Media Buying Agencies" },
  { label: "541840", value: "Media Representatives" },
  { label: "541850", value: "Indoor and Outdoor Display Advertising" },
  { label: "541860", value: "Direct Mail Advertising" },
  { label: "541870", value: "Advertising Material Distribution Services" },
  { label: "541890", value: "Other Services Related to Advertising" },
  { label: "5419", value: "Other Professional, Scientific, and Technical Services" },
  { label: "541910", value: "Marketing Research and Public Opinion Polling" },
  { label: "541921", value: "Photography Studios, Portrait" },
  { label: "541922", value: "Commercial Photography" },
  { label: "541930", value: "Translation and Interpretation Services" },
  { label: "541940", value: "Veterinary Services" },
  {
    label: "541990",
    value: "All Other Professional, Scientific, and Technical Services",
  },
  { label: "55", value: "Management of Companies and Enterprises" },
  { label: "551111", value: "Offices of Bank Holding Companies" },
  { label: "551112", value: "Offices of Other Holding Companies" },
  { label: "551114", value: "Corporate, Subsidiary, and Regional Managing Offices" },
  { label: "5511", value: "Management of Companies and Enterprises" },
  { label: "551111", value: "Offices of Bank Holding Companies" },
  { label: "551112", value: "Offices of Other Holding Companies" },
  { label: "551114", value: "Corporate, Subsidiary, and Regional Managing Offices" },
  {
    label: "56",
    value: "Administrative and Support and Waste Management and Remediation Services",
  },
  { label: "561110", value: "Office Administrative Services" },
  { label: "561210", value: "Facilities Support Services" },
  { label: "561311", value: "Employment Placement Agencies" },
  { label: "561312", value: "Executive Search Services" },
  { label: "561320", value: "Temporary Help Services" },
  { label: "561330", value: "Professional Employer Organizations" },
  { label: "561410", value: "Document Preparation Services" },
  { label: "561421", value: "Telephone Answering Services" },
  { label: "561422", value: "Telemarketing Bureaus and Other Contact Centers" },
  { label: "561431", value: "Private Mail Centers" },
  { label: "561439", value: "Other Business Service Centers (including Copy Shops)" },
  { label: "561440", value: "Collection Agencies" },
  { label: "561450", value: "Credit Bureaus" },
  { label: "561491", value: "Repossession Services" },
  { label: "561492", value: "Court Reporting and Stenotype Services" },
  { label: "561499", value: "All Other Business Support Services" },
  { label: "561510", value: "Travel Agencies" },
  { label: "561520", value: "Tour Operators" },
  { label: "561591", value: "Convention and Visitors Bureaus" },
  { label: "561599", value: "All Other Travel Arrangement and Reservation Services" },
  { label: "561611", value: "Investigation and Personal Background Check Services" },
  { label: "561612", value: "Security Guards and Patrol Services" },
  { label: "561613", value: "Armored Car Services" },
  { label: "561621", value: "Security Systems Services (except Locksmiths)" },
  { label: "561622", value: "Locksmiths" },
  { label: "561710", value: "Exterminating and Pest Control Services" },
  { label: "561720", value: "Janitorial Services" },
  { label: "561730", value: "Landscaping Services" },
  { label: "561740", value: "Carpet and Upholstery Cleaning Services" },
  { label: "561790", value: "Other Services to Buildings and Dwellings" },
  { label: "561910", value: "Packaging and Labeling Services" },
  { label: "561920", value: "Convention and Trade Show Organizers" },
  { label: "561990", value: "All Other Support Services" },
  { label: "562111", value: "Solid Waste Collection" },
  { label: "562112", value: "Hazardous Waste Collection" },
  { label: "562119", value: "Other Waste Collection" },
  { label: "562211", value: "Hazardous Waste Treatment and Disposal" },
  { label: "562212", value: "Solid Waste Landfill" },
  { label: "562213", value: "Solid Waste Combustors and Incinerators" },
  { label: "562219", value: "Other Nonhazardous Waste Treatment and Disposal" },
  { label: "562910", value: "Remediation Services" },
  { label: "562920", value: "Materials Recovery Facilities" },
  { label: "562991", value: "Septic Tank and Related Services" },
  { label: "562998", value: "All Other Miscellaneous Waste Management Services" },
  { label: "5611", value: "Office Administrative Services" },
  { label: "561110", value: "Office Administrative Services" },
  { label: "5612", value: "Facilities Support Services" },
  { label: "561210", value: "Facilities Support Services" },
  { label: "5613", value: "Employment Services" },
  { label: "561311", value: "Employment Placement Agencies" },
  { label: "561312", value: "Executive Search Services" },
  { label: "561320", value: "Temporary Help Services" },
  { label: "561330", value: "Professional Employer Organizations" },
  { label: "5614", value: "Business Support Services" },
  { label: "561410", value: "Document Preparation Services" },
  { label: "561421", value: "Telephone Answering Services" },
  { label: "561422", value: "Telemarketing Bureaus and Other Contact Centers" },
  { label: "561431", value: "Private Mail Centers" },
  { label: "561439", value: "Other Business Service Centers (including Copy Shops)" },
  { label: "561440", value: "Collection Agencies" },
  { label: "561450", value: "Credit Bureaus" },
  { label: "561491", value: "Repossession Services" },
  { label: "561492", value: "Court Reporting and Stenotype Services" },
  { label: "561499", value: "All Other Business Support Services" },
  { label: "5615", value: "Travel Arrangement and Reservation Services" },
  { label: "561510", value: "Travel Agencies" },
  { label: "561520", value: "Tour Operators" },
  { label: "561591", value: "Convention and Visitors Bureaus" },
  { label: "561599", value: "All Other Travel Arrangement and Reservation Services" },
  { label: "5616", value: "Investigation and Security Services" },
  { label: "561611", value: "Investigation and Personal Background Check Services" },
  { label: "561612", value: "Security Guards and Patrol Services" },
  { label: "561613", value: "Armored Car Services" },
  { label: "561621", value: "Security Systems Services (except Locksmiths)" },
  { label: "561622", value: "Locksmiths" },
  { label: "5617", value: "Services to Buildings and Dwellings" },
  { label: "561710", value: "Exterminating and Pest Control Services" },
  { label: "561720", value: "Janitorial Services" },
  { label: "561730", value: "Landscaping Services" },
  { label: "561740", value: "Carpet and Upholstery Cleaning Services" },
  { label: "561790", value: "Other Services to Buildings and Dwellings" },
  { label: "5619", value: "Other Support Services" },
  { label: "561910", value: "Packaging and Labeling Services" },
  { label: "561920", value: "Convention and Trade Show Organizers" },
  { label: "561990", value: "All Other Support Services" },
  { label: "5621", value: "Waste Collection" },
  { label: "562111", value: "Solid Waste Collection" },
  { label: "562112", value: "Hazardous Waste Collection" },
  { label: "562119", value: "Other Waste Collection" },
  { label: "5622", value: "Waste Treatment and Disposal" },
  { label: "562211", value: "Hazardous Waste Treatment and Disposal" },
  { label: "562212", value: "Solid Waste Landfill" },
  { label: "562213", value: "Solid Waste Combustors and Incinerators" },
  { label: "562219", value: "Other Nonhazardous Waste Treatment and Disposal" },
  { label: "5629", value: "Remediation and Other Waste Management Services" },
  { label: "562910", value: "Remediation Services" },
  { label: "562920", value: "Materials Recovery Facilities" },
  { label: "562991", value: "Septic Tank and Related Services" },
  { label: "562998", value: "All Other Miscellaneous Waste Management Services" },
  { label: "61", value: "Educational Services" },
  { label: "611110", value: "Elementary and Secondary Schools" },
  { label: "611210", value: "Junior Colleges" },
  { label: "611310", value: "Colleges, Universities, and Professional Schools" },
  { label: "611410", value: "Business and Secretarial Schools" },
  { label: "611420", value: "Computer Training" },
  { label: "611430", value: "Professional and Management Development Training" },
  { label: "611511", value: "Cosmetology and Barber Schools" },
  { label: "611512", value: "Flight Training" },
  { label: "611513", value: "Apprenticeship Training" },
  { label: "611519", value: "Other Technical and Trade Schools" },
  { label: "611610", value: "Fine Arts Schools" },
  { label: "611620", value: "Sports and Recreation Instruction" },
  { label: "611630", value: "Language Schools" },
  { label: "611691", value: "Exam Preparation and Tutoring" },
  { label: "611692", value: "Automobile Driving Schools" },
  { label: "611699", value: "All Other Miscellaneous Schools and Instruction" },
  { label: "611710", value: "Educational Support Services" },
  { label: "6111", value: "Elementary and Secondary Schools" },
  { label: "611110", value: "Elementary and Secondary Schools" },
  { label: "6112", value: "Junior Colleges" },
  { label: "611210", value: "Junior Colleges" },
  { label: "6113", value: "Colleges, Universities, and Professional Schools" },
  { label: "611310", value: "Colleges, Universities, and Professional Schools" },
  { label: "6114", value: "Business Schools and Computer and Management Training" },
  { label: "611410", value: "Business and Secretarial Schools" },
  { label: "611420", value: "Computer Training" },
  { label: "611430", value: "Professional and Management Development Training" },
  { label: "6115", value: "Technical and Trade Schools" },
  { label: "611511", value: "Cosmetology and Barber Schools" },
  { label: "611512", value: "Flight Training" },
  { label: "611513", value: "Apprenticeship Training" },
  { label: "611519", value: "Other Technical and Trade Schools" },
  { label: "6116", value: "Other Schools and Instruction" },
  { label: "611610", value: "Fine Arts Schools" },
  { label: "611620", value: "Sports and Recreation Instruction" },
  { label: "611630", value: "Language Schools" },
  { label: "611691", value: "Exam Preparation and Tutoring" },
  { label: "611692", value: "Automobile Driving Schools" },
  { label: "611699", value: "All Other Miscellaneous Schools and Instruction" },
  { label: "6117", value: "Educational Support Services" },
  { label: "611710", value: "Educational Support Services" },
  { label: "62", value: "Health Care and Social Assistance" },
  { label: "621111", value: "Offices of Physicians (except Mental Health Specialists)" },
  { label: "621112", value: "Offices of Physicians, Mental Health Specialists" },
  { label: "621210", value: "Offices of Dentists" },
  { label: "621310", value: "Offices of Chiropractors" },
  { label: "621320", value: "Offices of Optometrists" },
  {
    label: "621330",
    value: "Offices of Mental Health Practitioners (except Physicians)",
  },
  {
    label: "621340",
    value: "Offices of Physical, Occupational and Speech Therapists, and Audiologists",
  },
  { label: "621391", value: "Offices of Podiatrists" },
  { label: "621399", value: "Offices of All Other Miscellaneous Health Practitioners" },
  { label: "621410", value: "Family Planning Centers" },
  { label: "621420", value: "Outpatient Mental Health and Substance Abuse Centers" },
  { label: "621491", value: "HMO Medical Centers" },
  { label: "621492", value: "Kidney Dialysis Centers" },
  { label: "621493", value: "Freestanding Ambulatory Surgical and Emergency Centers" },
  { label: "621498", value: "All Other Outpatient Care Centers" },
  { label: "621511", value: "Medical Laboratories" },
  { label: "621512", value: "Diagnostic Imaging Centers" },
  { label: "621610", value: "Home Health Care Services" },
  { label: "621910", value: "Ambulance Services" },
  { label: "621991", value: "Blood and Organ Banks" },
  { label: "621999", value: "All Other Miscellaneous Ambulatory Health Care Services" },
  { label: "622110", value: "General Medical and Surgical Hospitals" },
  { label: "622210", value: "Psychiatric and Substance Abuse Hospitals" },
  {
    label: "622310",
    value: "Specialty (except Psychiatric and Substance Abuse) Hospitals",
  },
  { label: "623110", value: "Nursing Care Facilities (Skilled Nursing Facilities)" },
  {
    label: "623210",
    value: "Residential Intellectual and Developmental Disability Facilities",
  },
  { label: "623220", value: "Residential Mental Health and Substance Abuse Facilities" },
  { label: "623311", value: "Continuing Care Retirement Communities" },
  { label: "623312", value: "Assisted Living Facilities for the Elderly" },
  { label: "623990", value: "Other Residential Care Facilities" },
  { label: "624110", value: "Child and Youth Services" },
  { label: "624120", value: "Services for the Elderly and Persons with Disabilities" },
  { label: "624190", value: "Other Individual and Family Services" },
  { label: "624210", value: "Community Food Services" },
  { label: "624221", value: "Temporary Shelters" },
  { label: "624229", value: "Other Community Housing Services" },
  { label: "624230", value: "Emergency and Other Relief Services" },
  { label: "624310", value: "Vocational Rehabilitation Services" },
  { label: "624410", value: "Child Care Services" },
  { label: "6211", value: "Offices of Physicians" },
  { label: "621111", value: "Offices of Physicians (except Mental Health Specialists)" },
  { label: "621112", value: "Offices of Physicians, Mental Health Specialists" },
  { label: "6212", value: "Offices of Dentists" },
  { label: "621210", value: "Offices of Dentists" },
  { label: "6213", value: "Offices of Other Health Practitioners" },
  { label: "621310", value: "Offices of Chiropractors" },
  { label: "621320", value: "Offices of Optometrists" },
  {
    label: "621330",
    value: "Offices of Mental Health Practitioners (except Physicians)",
  },
  {
    label: "621340",
    value: "Offices of Physical, Occupational and Speech Therapists, and Audiologists",
  },
  { label: "621391", value: "Offices of Podiatrists" },
  { label: "621399", value: "Offices of All Other Miscellaneous Health Practitioners" },
  { label: "6214", value: "Outpatient Care Centers" },
  { label: "621410", value: "Family Planning Centers" },
  { label: "621420", value: "Outpatient Mental Health and Substance Abuse Centers" },
  { label: "621491", value: "HMO Medical Centers" },
  { label: "621492", value: "Kidney Dialysis Centers" },
  { label: "621493", value: "Freestanding Ambulatory Surgical and Emergency Centers" },
  { label: "621498", value: "All Other Outpatient Care Centers" },
  { label: "6215", value: "Medical and Diagnostic Laboratories" },
  { label: "621511", value: "Medical Laboratories" },
  { label: "621512", value: "Diagnostic Imaging Centers" },
  { label: "6216", value: "Home Health Care Services" },
  { label: "621610", value: "Home Health Care Services" },
  { label: "6219", value: "Other Ambulatory Health Care Services" },
  { label: "621910", value: "Ambulance Services" },
  { label: "621991", value: "Blood and Organ Banks" },
  { label: "621999", value: "All Other Miscellaneous Ambulatory Health Care Services" },
  { label: "6221", value: "General Medical and Surgical Hospitals" },
  { label: "622110", value: "General Medical and Surgical Hospitals" },
  { label: "6222", value: "Psychiatric and Substance Abuse Hospitals" },
  { label: "622210", value: "Psychiatric and Substance Abuse Hospitals" },
  {
    label: "6223",
    value: "Specialty (except Psychiatric and Substance Abuse) Hospitals",
  },
  {
    label: "622310",
    value: "Specialty (except Psychiatric and Substance Abuse) Hospitals",
  },
  { label: "6231", value: "Nursing Care Facilities (Skilled Nursing Facilities)" },
  { label: "623110", value: "Nursing Care Facilities (Skilled Nursing Facilities)" },
  {
    label: "6232",
    value:
      "Residential Intellectual and Developmental Disability, Mental Health, and Substance Abuse Facilities",
  },
  {
    label: "623210",
    value: "Residential Intellectual and Developmental Disability Facilities",
  },
  { label: "623220", value: "Residential Mental Health and Substance Abuse Facilities" },
  {
    label: "6233",
    value:
      "Continuing Care Retirement Communities and Assisted Living Facilities for the Elderly",
  },
  { label: "623311", value: "Continuing Care Retirement Communities" },
  { label: "623312", value: "Assisted Living Facilities for the Elderly" },
  { label: "6239", value: "Other Residential Care Facilities" },
  { label: "623990", value: "Other Residential Care Facilities" },
  { label: "6241", value: "Individual and Family Services" },
  { label: "624110", value: "Child and Youth Services" },
  { label: "624120", value: "Services for the Elderly and Persons with Disabilities" },
  { label: "624190", value: "Other Individual and Family Services" },
  {
    label: "6242",
    value: "Community Food and Housing, and Emergency and Other Relief Services",
  },
  { label: "624210", value: "Community Food Services" },
  { label: "624221", value: "Temporary Shelters" },
  { label: "624229", value: "Other Community Housing Services" },
  { label: "624230", value: "Emergency and Other Relief Services" },
  { label: "6243", value: "Vocational Rehabilitation Services" },
  { label: "624310", value: "Vocational Rehabilitation Services" },
  { label: "6244", value: "Child Care Services" },
  { label: "624410", value: "Child Care Services" },
  { label: "71", value: "Arts, Entertainment, and Recreation" },
  { label: "711110", value: "Theater Companies and Dinner Theaters" },
  { label: "711120", value: "Dance Companies" },
  { label: "711130", value: "Musical Groups and Artists" },
  { label: "711190", value: "Other Performing Arts Companies" },
  { label: "711211", value: "Sports Teams and Clubs" },
  { label: "711212", value: "Racetracks" },
  { label: "711219", value: "Other Spectator Sports" },
  {
    label: "711310",
    value: "Promoters of Performing Arts, Sports, and Similar Events with Facilities",
  },
  {
    label: "711320",
    value: "Promoters of Performing Arts, Sports, and Similar Events without Facilities",
  },
  {
    label: "711410",
    value:
      "Agents and Managers for Artists, Athletes, Entertainers, and Other Public Figures",
  },
  { label: "711510", value: "Independent Artists, Writers, and Performers" },
  { label: "712110", value: "Museums" },
  { label: "712120", value: "Historical Sites" },
  { label: "712130", value: "Zoos and Botanical Gardens" },
  { label: "712190", value: "Nature Parks and Other Similar Institutions" },
  { label: "713110", value: "Amusement and Theme Parks" },
  { label: "713120", value: "Amusement Arcades" },
  { label: "713210", value: "Casinos (except Casino Hotels)" },
  { label: "713290", value: "Other Gambling Industries" },
  { label: "713910", value: "Golf Courses and Country Clubs" },
  { label: "713920", value: "Skiing Facilities" },
  { label: "713930", value: "Marinas" },
  { label: "713940", value: "Fitness and Recreational Sports Centers" },
  { label: "713950", value: "Bowling Centers" },
  { label: "713990", value: "All Other Amusement and Recreation Industries" },
  { label: "7111", value: "Performing Arts Companies" },
  { label: "711110", value: "Theater Companies and Dinner Theaters" },
  { label: "711120", value: "Dance Companies" },
  { label: "711130", value: "Musical Groups and Artists" },
  { label: "711190", value: "Other Performing Arts Companies" },
  { label: "7112", value: "Spectator Sports" },
  { label: "711211", value: "Sports Teams and Clubs" },
  { label: "711212", value: "Racetracks" },
  { label: "711219", value: "Other Spectator Sports" },
  { label: "7113", value: "Promoters of Performing Arts, Sports, and Similar Events" },
  {
    label: "711310",
    value: "Promoters of Performing Arts, Sports, and Similar Events with Facilities",
  },
  {
    label: "711320",
    value: "Promoters of Performing Arts, Sports, and Similar Events without Facilities",
  },
  {
    label: "7114",
    value:
      "Agents and Managers for Artists, Athletes, Entertainers, and Other Public Figures",
  },
  {
    label: "711410",
    value:
      "Agents and Managers for Artists, Athletes, Entertainers, and Other Public Figures",
  },
  { label: "7115", value: "Independent Artists, Writers, and Performers" },
  { label: "711510", value: "Independent Artists, Writers, and Performers" },
  { label: "7121", value: "Museums, Historical Sites, and Similar Institutions" },
  { label: "712110", value: "Museums" },
  { label: "712120", value: "Historical Sites" },
  { label: "712130", value: "Zoos and Botanical Gardens" },
  { label: "712190", value: "Nature Parks and Other Similar Institutions" },
  { label: "7131", value: "Amusement Parks and Arcades" },
  { label: "713110", value: "Amusement and Theme Parks" },
  { label: "713120", value: "Amusement Arcades" },
  { label: "7132", value: "Gambling Industries" },
  { label: "713210", value: "Casinos (except Casino Hotels)" },
  { label: "713290", value: "Other Gambling Industries" },
  { label: "7139", value: "Other Amusement and Recreation Industries" },
  { label: "713910", value: "Golf Courses and Country Clubs" },
  { label: "713920", value: "Skiing Facilities" },
  { label: "713930", value: "Marinas" },
  { label: "713940", value: "Fitness and Recreational Sports Centers" },
  { label: "713950", value: "Bowling Centers" },
  { label: "713990", value: "All Other Amusement and Recreation Industries" },
  { label: "72", value: "Accommodation and Food Services" },
  { label: "721110", value: "Hotels (except Casino Hotels) and Motels" },
  { label: "721120", value: "Casino Hotels" },
  { label: "721191", value: "Bed-and-Breakfast Inns" },
  { label: "721199", value: "All Other Traveler Accommodation" },
  { label: "721211", value: "RV (Recreational Vehicle) Parks and Campgrounds" },
  { label: "721214", value: "Recreational and Vacation Camps (except Campgrounds)" },
  {
    label: "721310",
    value: "Rooming and Boarding Houses, Dormitories, and Workers' Camps",
  },
  { label: "722310", value: "Food Service Contractors" },
  { label: "722320", value: "Caterers" },
  { label: "722330", value: "Mobile Food Services" },
  { label: "722410", value: "Drinking Places (Alcoholic Beverages)" },
  { label: "722511", value: "Full-Service Restaurants" },
  { label: "722513", value: "Limited-Service Restaurants" },
  { label: "722514", value: "Cafeterias, Grill Buffets, and Buffets" },
  { label: "722515", value: "Snack and Nonalcoholic Beverage Bars" },
  { label: "7211", value: "Traveler Accommodation" },
  { label: "721110", value: "Hotels (except Casino Hotels) and Motels" },
  { label: "721120", value: "Casino Hotels" },
  { label: "721191", value: "Bed-and-Breakfast Inns" },
  { label: "721199", value: "All Other Traveler Accommodation" },
  { label: "7212", value: "RV (Recreational Vehicle) Parks and Recreational Camps" },
  { label: "721211", value: "RV (Recreational Vehicle) Parks and Campgrounds" },
  { label: "721214", value: "Recreational and Vacation Camps (except Campgrounds)" },
  {
    label: "7213",
    value: "Rooming and Boarding Houses, Dormitories, and Workers' Camps",
  },
  {
    label: "721310",
    value: "Rooming and Boarding Houses, Dormitories, and Workers' Camps",
  },
  { label: "7223", value: "Special Food Services" },
  { label: "722310", value: "Food Service Contractors" },
  { label: "722320", value: "Caterers" },
  { label: "722330", value: "Mobile Food Services" },
  { label: "7224", value: "Drinking Places (Alcoholic Beverages)" },
  { label: "722410", value: "Drinking Places (Alcoholic Beverages)" },
  { label: "7225", value: "Restaurants and Other Eating Places" },
  { label: "722511", value: "Full-Service Restaurants" },
  { label: "722513", value: "Limited-Service Restaurants" },
  { label: "722514", value: "Cafeterias, Grill Buffets, and Buffets" },
  { label: "722515", value: "Snack and Nonalcoholic Beverage Bars" },
  { label: "81", value: "Other Services (except Public Administration)" },
  { label: "811111", value: "General Automotive Repair" },
  { label: "811114", value: "Specialized Automotive Repair" },
  {
    label: "811121",
    value: "Automotive Body, Paint, and Interior Repair and Maintenance",
  },
  { label: "811122", value: "Automotive Glass Replacement Shops" },
  { label: "811191", value: "Automotive Oil Change and Lubrication Shops" },
  { label: "811192", value: "Car Washes" },
  { label: "811198", value: "All Other Automotive Repair and Maintenance" },
  { label: "811210", value: "Electronic and Precision Equipment Repair and Maintenance" },
  {
    label: "811310",
    value:
      "Commercial and Industrial Machinery and Equipment (except Automotive and Electronic) Repair and Maintenance",
  },
  { label: "811411", value: "Home and Garden Equipment Repair and Maintenance" },
  { label: "811412", value: "Appliance Repair and Maintenance" },
  { label: "811420", value: "Reupholstery and Furniture Repair" },
  { label: "811430", value: "Footwear and Leather Goods Repair" },
  { label: "811490", value: "Other Personal and Household Goods Repair and Maintenance" },
  { label: "812111", value: "Barber Shops" },
  { label: "812112", value: "Beauty Salons" },
  { label: "812113", value: "Nail Salons" },
  { label: "812191", value: "Diet and Weight Reducing Centers" },
  { label: "812199", value: "Other Personal Care Services" },
  { label: "812210", value: "Funeral Homes and Funeral Services" },
  { label: "812220", value: "Cemeteries and Crematories" },
  { label: "812310", value: "Coin-Operated Laundries and Drycleaners" },
  { label: "812320", value: "Drycleaning and Laundry Services (except Coin-Operated)" },
  { label: "812331", value: "Linen Supply" },
  { label: "812332", value: "Industrial Launderers" },
  { label: "812910", value: "Pet Care (except Veterinary) Services" },
  { label: "812921", value: "Photofinishing Laboratories (except One-Hour)" },
  { label: "812922", value: "One-Hour Photofinishing" },
  { label: "812930", value: "Parking Lots and Garages" },
  { label: "812990", value: "All Other Personal Services" },
  { label: "813110", value: "Religious Organizations" },
  { label: "813211", value: "Grantmaking Foundations" },
  { label: "813212", value: "Voluntary Health Organizations" },
  { label: "813219", value: "Other Grantmaking and Giving Services" },
  { label: "813311", value: "Human Rights Organizations" },
  { label: "813312", value: "Environment, Conservation and Wildlife Organizations" },
  { label: "813319", value: "Other Social Advocacy Organizations" },
  { label: "813410", value: "Civic and Social Organizations" },
  { label: "813910", value: "Business Associations" },
  { label: "813920", value: "Professional Organizations" },
  { label: "813930", value: "Labor Unions and Similar Labor Organizations" },
  { label: "813940", value: "Political Organizations" },
  {
    label: "813990",
    value:
      "Other Similar Organizations (except Business, Professional, Labor, and Political Organizations)",
  },
  { label: "814110", value: "Private Households" },
  { label: "8111", value: "Automotive Repair and Maintenance" },
  { label: "811111", value: "General Automotive Repair" },
  { label: "811114", value: "Specialized Automotive Repair" },
  {
    label: "811121",
    value: "Automotive Body, Paint, and Interior Repair and Maintenance",
  },
  { label: "811122", value: "Automotive Glass Replacement Shops" },
  { label: "811191", value: "Automotive Oil Change and Lubrication Shops" },
  { label: "811192", value: "Car Washes" },
  { label: "811198", value: "All Other Automotive Repair and Maintenance" },
  { label: "8112", value: "Electronic and Precision Equipment Repair and Maintenance" },
  { label: "811210", value: "Electronic and Precision Equipment Repair and Maintenance" },
  {
    label: "8113",
    value:
      "Commercial and Industrial Machinery and Equipment (except Automotive and Electronic) Repair and Maintenance",
  },
  {
    label: "811310",
    value:
      "Commercial and Industrial Machinery and Equipment (except Automotive and Electronic) Repair and Maintenance",
  },
  { label: "8114", value: "Personal and Household Goods Repair and Maintenance" },
  { label: "811411", value: "Home and Garden Equipment Repair and Maintenance" },
  { label: "811412", value: "Appliance Repair and Maintenance" },
  { label: "811420", value: "Reupholstery and Furniture Repair" },
  { label: "811430", value: "Footwear and Leather Goods Repair" },
  { label: "811490", value: "Other Personal and Household Goods Repair and Maintenance" },
  { label: "8121", value: "Personal Care Services" },
  { label: "812111", value: "Barber Shops" },
  { label: "812112", value: "Beauty Salons" },
  { label: "812113", value: "Nail Salons" },
  { label: "812191", value: "Diet and Weight Reducing Centers" },
  { label: "812199", value: "Other Personal Care Services" },
  { label: "8122", value: "Death Care Services" },
  { label: "812210", value: "Funeral Homes and Funeral Services" },
  { label: "812220", value: "Cemeteries and Crematories" },
  { label: "8123", value: "Drycleaning and Laundry Services" },
  { label: "812310", value: "Coin-Operated Laundries and Drycleaners" },
  { label: "812320", value: "Drycleaning and Laundry Services (except Coin-Operated)" },
  { label: "812331", value: "Linen Supply" },
  { label: "812332", value: "Industrial Launderers" },
  { label: "8129", value: "Other Personal Services" },
  { label: "812910", value: "Pet Care (except Veterinary) Services" },
  { label: "812921", value: "Photofinishing Laboratories (except One-Hour)" },
  { label: "812922", value: "One-Hour Photofinishing" },
  { label: "812930", value: "Parking Lots and Garages" },
  { label: "812990", value: "All Other Personal Services" },
  { label: "8131", value: "Religious Organizations" },
  { label: "813110", value: "Religious Organizations" },
  { label: "8132", value: "Grantmaking and Giving Services" },
  { label: "813211", value: "Grantmaking Foundations" },
  { label: "813212", value: "Voluntary Health Organizations" },
  { label: "813219", value: "Other Grantmaking and Giving Services" },
  { label: "8133", value: "Social Advocacy Organizations" },
  { label: "813311", value: "Human Rights Organizations" },
  { label: "813312", value: "Environment, Conservation and Wildlife Organizations" },
  { label: "813319", value: "Other Social Advocacy Organizations" },
  { label: "8134", value: "Civic and Social Organizations" },
  { label: "813410", value: "Civic and Social Organizations" },
  {
    label: "8139",
    value: "Business, Professional, Labor, Political, and Similar Organizations",
  },
  { label: "813910", value: "Business Associations" },
  { label: "813920", value: "Professional Organizations" },
  { label: "813930", value: "Labor Unions and Similar Labor Organizations" },
  { label: "813940", value: "Political Organizations" },
  {
    label: "813990",
    value:
      "Other Similar Organizations (except Business, Professional, Labor, and Political Organizations)",
  },
  { label: "8141", value: "Private Households" },
  { label: "814110", value: "Private Households" },
  { label: "92", value: "Public Administration" },
  { label: "921110", value: "Executive Offices" },
  { label: "921120", value: "Legislative Bodies" },
  { label: "921130", value: "Public Finance Activities" },
  { label: "921140", value: "Executive and Legislative Offices, Combined" },
  { label: "921150", value: "American Indian and Alaska Native Tribal Governments" },
  { label: "921190", value: "Other General Government Support" },
  { label: "922110", value: "Courts" },
  { label: "922120", value: "Police Protection" },
  { label: "922130", value: "Legal Counsel and Prosecution" },
  { label: "922140", value: "Correctional Institutions" },
  { label: "922150", value: "Parole Offices and Probation Offices" },
  { label: "922160", value: "Fire Protection" },
  { label: "922190", value: "Other Justice, Public Order, and Safety Activities" },
  { label: "923110", value: "Administration of Education Programs" },
  { label: "923120", value: "Administration of Public Health Programs" },
  {
    label: "923130",
    value:
      "Administration of Human Resource Programs (except Education, Public Health, and Veterans' Affairs Programs)",
  },
  { label: "923140", value: "Administration of Veterans' Affairs" },
  {
    label: "924110",
    value: "Administration of Air and Water Resource and Solid Waste Management Programs",
  },
  { label: "924120", value: "Administration of Conservation Programs" },
  { label: "925110", value: "Administration of Housing Programs" },
  {
    label: "925120",
    value: "Administration of Urban Planning and Community and Rural Development",
  },
  { label: "926110", value: "Administration of General Economic Programs" },
  { label: "926120", value: "Regulation and Administration of Transportation Programs" },
  {
    label: "926130",
    value:
      "Regulation and Administration of Communications, Electric, Gas, and Other Utilities",
  },
  { label: "926140", value: "Regulation of Agricultural Marketing and Commodities" },
  {
    label: "926150",
    value: "Regulation, Licensing, and Inspection of Miscellaneous Commercial Sectors",
  },
  { label: "927110", value: "Space Research and Technology" },
  { label: "928110", value: "National Security" },
  { label: "928120", value: "International Affairs" },
  {
    label: "9211",
    value: "Executive, Legislative, and Other General Government Support",
  },
  { label: "921110", value: "Executive Offices" },
  { label: "921120", value: "Legislative Bodies" },
  { label: "921130", value: "Public Finance Activities" },
  { label: "921140", value: "Executive and Legislative Offices, Combined" },
  { label: "921150", value: "American Indian and Alaska Native Tribal Governments" },
  { label: "921190", value: "Other General Government Support" },
  { label: "9221", value: "Justice, Public Order, and Safety Activities" },
  { label: "922110", value: "Courts" },
  { label: "922120", value: "Police Protection" },
  { label: "922130", value: "Legal Counsel and Prosecution" },
  { label: "922140", value: "Correctional Institutions" },
  { label: "922150", value: "Parole Offices and Probation Offices" },
  { label: "922160", value: "Fire Protection" },
  { label: "922190", value: "Other Justice, Public Order, and Safety Activities" },
  { label: "9231", value: "Administration of Human Resource Programs" },
  { label: "923110", value: "Administration of Education Programs" },
  { label: "923120", value: "Administration of Public Health Programs" },
  {
    label: "923130",
    value:
      "Administration of Human Resource Programs (except Education, Public Health, and Veterans' Affairs Programs)",
  },
  { label: "923140", value: "Administration of Veterans' Affairs" },
  { label: "9241", value: "Administration of Environmental Quality Programs" },
  {
    label: "924110",
    value: "Administration of Air and Water Resource and Solid Waste Management Programs",
  },
  { label: "924120", value: "Administration of Conservation Programs" },
  {
    label: "9251",
    value:
      "Administration of Housing Programs, Urban Planning, and Community Development",
  },
  { label: "925110", value: "Administration of Housing Programs" },
  {
    label: "925120",
    value: "Administration of Urban Planning and Community and Rural Development",
  },
  { label: "9261", value: "Administration of Economic Programs" },
  { label: "926110", value: "Administration of General Economic Programs" },
  { label: "926120", value: "Regulation and Administration of Transportation Programs" },
  {
    label: "926130",
    value:
      "Regulation and Administration of Communications, Electric, Gas, and Other Utilities",
  },
  { label: "926140", value: "Regulation of Agricultural Marketing and Commodities" },
  {
    label: "926150",
    value: "Regulation, Licensing, and Inspection of Miscellaneous Commercial Sectors",
  },
  { label: "9271", value: "Space Research and Technology" },
  { label: "927110", value: "Space Research and Technology" },
  { label: "9281", value: "National Security and International Affairs" },
  { label: "928110", value: "National Security" },
  { label: "928120", value: "International Affairs" },
];
